import axios, { AxiosError } from "axios";
import _, { Dictionary, concat, filter, first, groupBy, isMatch, max, over, reverse, sample, set, split, take, uniq, update } from "lodash";
import { Mean, StandardError } from "../utilities/Stats";
import getCookie from "./Cookie";
import "../../appAnalysis/types";
import { stringToColorDefault, stringToColor, defaultColorMap, colorScaleMap } from "./Colors";
// import * as d3 from "d3";
import { agnes } from 'ml-hclust';
// import { data } from "@tensorflow/tfjs";
// import clusterfck from 'clusterfck';
import { getFilterKeys, getIndexMapOfStrArray } from './utils'
import { configureCallbacks } from "@tensorflow/tfjs-layers/dist/base_callbacks";
import { ErrorBar, newPlot } from "plotly.js";
import { clusterOrder, clusterAPI, checkForNulls } from "./utils";
import { data, keep, tile } from "@tensorflow/tfjs";
import PlotControls from "../components/PlotControls";
import { error } from "geotiff/dist-node/logging";
import { re } from "mathjs";
import { Search } from "react-router-dom";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import { isNullishCoalesce } from "typescript";

const areArraysEqual = (arr1: any[], arr2: any[]) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((element, index) => element === arr2[index]);
  };

export const generateTiledPlots = async (
    dataList: any,
    xValues: any,
    yValues: any,
    categories: any,
    sharedX: boolean,
    plotFunction: PlotFunction | PlotFunctionAsync,
    plotConfig: PlotConfig,
    ...plotFunctionArgs: any[]
    
): Promise<any> => {

    let processingErrors = ''
    let traces: any[] = []
    // let updatedPlotData = filterAxis(axisFiltersState, plotData)
    // let aggregatedData;
    // let aggregationError;
    // let normalizedData;
    // let normalizeError;


    // let relativedData;
    // let relativeError;

    // aggregatedData = sampleGroupStep(updatedPlotData, activeSampleGroupDict);
    // ({plotData: normalizedData, error: normalizeError } = normalizeData(aggregatedData, xValues, xProcessing, yValues, yProcessing, axisFiltersState));
    // ({plotData: aggregatedData, error: aggregationError} = aggregateData(normalizedData, xValues, xProcessing, yValues, yProcessing, axisFiltersState, sortOrder));
    // ({plotData: relativedData, error: relativeError} = relativeData(aggregatedData, xValues, xProcessing, yValues, yProcessing, axisFiltersState));
   
    
    // let trueTiles = tileState ? Object.keys(tileState).filter((key: any) => tileState[key] === true) : []
    // let splitTileList = trueTiles.map((tile: any) => {let splitTile = tile.split('|'); return splitTile[0] + '|' + splitTile[1]})
    

    // let tileDict = buildGroupByDict(relativedData, splitTileList)

    // let tileOrder: string[] = Object.keys(tileDict)
    // if (splitTileList.length > 0) {
    //     for (let key in axisFiltersState) {
    //         let newString = axisFiltersState[key].versionType + '|' + axisFiltersState[key].column
    //         if (trueTiles.includes(newString)) {
    //             let filterIndex = trueTiles.indexOf(newString)
    //             let filterOrder = axisFiltersState[key].value.map((item: any) => item.value)
    //             tileOrder.sort((a, b) => filterOrder.indexOf(a.split('|')[filterIndex]) - filterOrder.indexOf(b.split('|')[filterIndex]))
    //         }
    //     }
    // }

    // let dataList = generateCategoricalPlotDataDict(xValues, yValues, categories, relativedData, true, axisFiltersState, tileDict, tileOrder)
    
    // let tileTitleList = (tileOrder && tileOrder.length > 0) ? tileOrder : Object.keys(tileDict).map((data: any) => data)
    
    let firstOccurrenceDict: {[key: string]: boolean} = {}; 
    
    let subplotIndex = 1; // Start indexing for subplots

    const globalCatDict : Record<string, string> = {};
    let completeXAxisSet = new Set<string>();
    let xAxisCatOrders = [];
    let index = 0;
    for (let data of dataList) {
        let { dataDict, categoryDict } = data;
        const localKeys = Object.keys(categoryDict);
        xAxisCatOrders[index] = [...localKeys];
        localKeys.forEach((item:string) => {completeXAxisSet.add(item); globalCatDict[item] = categoryDict[item]})
    }

    const xAxisIndexMap: Record<string, number> = {};

    for (let i = 0; i< xAxisCatOrders.length; i++){ 
        const localOrder = getIndexMapOfStrArray(xAxisCatOrders[i]);
        // Store in xAxisIndexMap and take the rolling average
        for (let key in localOrder) {
            if (!(key in xAxisIndexMap)) {
                xAxisIndexMap[key] = localOrder[key];
            }
            else {
                xAxisIndexMap[key] += localOrder[key]/2;
            }
        }
    }
    // console.log("xAxisIndexMap: ", xAxisIndexMap);
    const xAxisList = Array.from(completeXAxisSet);
    // const xAxisIndexMap: Record<string, number> = getIndexMapOfStrArray(xAxisList)
    if (!plotConfig.colorOverride){
        plotConfig.colorOverride = {}
    }
    const overrideColors = new Set(Object.values(plotConfig.colorOverride || {}));
    const includeOverride = overrideColors.size >= Object.values(defaultColorMap).length - 4; 
    const availableColors = (Object.values(defaultColorMap) as string[]).filter(col => !overrideColors.has(col) || includeOverride) as string[];

    let colorIndex = 0;
    for (let data of dataList) {
        let { dataDict, categoryDict } = data

        for (let vt of Object.keys(dataDict)){
            for (let value of Object.keys(dataDict[vt])){
                for (let xAxisValue of xAxisList){
                    if (!(xAxisValue in dataDict[vt][value]) && sharedX){
                        dataDict[vt][value][xAxisValue] = []
                    }
                }
                const entries = Object.entries(dataDict[vt][value])
                entries.sort((a, b) => xAxisIndexMap[a[0]] - xAxisIndexMap[b[0]])
                const sortedDict = Object.fromEntries(entries)
                dataDict[vt][value] = sortedDict
            }
        }
        // console.log("Category Dict: ", categoryDict);
        // console.log("Global Category Dict: ", globalCatDict);
        // console.log("plotFunctionArgs: ", plotFunctionArgs);
        let singleTraces = await plotFunction(dataDict, (sharedX) ? globalCatDict : categoryDict, xValues, subplotIndex, availableColors, plotConfig, colorIndex, ...plotFunctionArgs);
        if (!sharedX) {
            colorIndex += Object.keys(categoryDict).length;
        }
        else {
            colorIndex += Object.keys(globalCatDict).length;
        }
        // Assign each trace to a specific subplot by setting the xaxis and yaxis properties
        singleTraces.forEach(trace => {
            trace.xaxis = `x${subplotIndex}`;
            trace.yaxis = `y${subplotIndex}`;
            trace.title = globalCatDict[trace.name];

            // Check if it is the first occurrence of the legend item
            if (!firstOccurrenceDict[trace.name] && trace.name !== '') {
                firstOccurrenceDict[trace.name] = true; // Mark it as occurred
                if (!trace.name.endsWith(' ')) {
                    trace.showlegend = true; // Show legend for the first occurrence
                }
            } else {
                trace.showlegend = false; // Hide legend for subsequent occurrences
            }
            traces.push(trace);
        });

        subplotIndex += 1;
    }

    return traces 
};

export const extractDataProcessing = (axisValues: any) => {
    for (let versionType in axisValues) {
        return {
                groupBy: axisValues[versionType].groupBy, 
                aggregationMethod: axisValues[versionType].aggregationMethod,
                normalizeBy: axisValues[versionType]?.normalizeBy ,
                normalizeUnits: axisValues[versionType]?.normalizeUnits ,
                references: axisValues[versionType]?.references,
                relativeUnits: axisValues[versionType]?.relativeUnits,
                processingMode: axisValues[versionType]?.processingMode,
                hideReference: axisValues[versionType]?.hideReference,
                groupByRelative: axisValues[versionType]?.groupByRelative,
                normReferences: axisValues[versionType]?.normReferences,
                normRelativeUnits: axisValues[versionType]?.normRelativeUnits,
                normHideReference: axisValues[versionType]?.normHideReference,
                groupByNormRelative: axisValues[versionType]?.groupByNormRelative,
                pathwayMode: axisValues[versionType]?.pathwayMode,
                pathwayScore: axisValues[versionType]?.pathwayScore,
            }
    }
}


const generatePvalueAnnotations = (plotPvalues:PValueDict | PValueDict[], dataDict:any, categoryDict:any, plotConfig: PlotConfig, xAxis: number, yAxis: number, rowMax: number, rowMin: number, tileIndex: number, plotErrorBars: ErrorBarDict | ErrorBarDict[]): {annotations: any[], shapes: any[] } => {
    const annotations = [];
    const shapes = [];
    const xAxisString = `x${xAxis !== 1 ? ''+xAxis : ''}`
    const yAxisString = `y${yAxis !== 1 ? ''+yAxis : ''}`

    
    let pvalMode: string | undefined = plotConfig.pvalueDisplayMode // or just 'text'
    let numLines: number = 0
    let runningMax: number = 0
    let prevTop: number = 0
    let kwPval: number = 0
    let offset: number = 3
    const offsetRatio: number = 0.03
    let indexMod = 0;
    if (plotConfig.plotType === 'box'){
        indexMod = 1
    }

    offset = (rowMax - rowMin) * offsetRatio
    
    let categories = Object.keys(categoryDict)
    categories = categories.map((cat) => categoryDict[cat])
    let reverseCatDict: { [key: string]: string } = {}
    for (const key of Object.keys(categoryDict)) {
        const value:string = categoryDict[key]
        reverseCatDict[value] = key;
    }
    if (!Array.isArray(plotPvalues)) {
        plotPvalues = [plotPvalues] as PValueDict[]
        plotErrorBars = [plotErrorBars] as ErrorBarDict[]
    }
    const plotPvaluesArray = plotPvalues as PValueDict[]
    const plotErrorBarsArray = plotErrorBars as ErrorBarDict[]

    if (plotConfig.pvalueControl !== undefined && (categories.includes(plotConfig.pvalueControl) || (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar'))) {
        const groupedCategories: string[] = []
        if (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar') {
            for (let i = 0; i < plotPvaluesArray.length; i++) {
                const dataIndex = i + tileIndex;
                const singlePlotPvalues = plotPvaluesArray[i] as PValueDict;
                for (let plotKey in dataDict ){    
                    for (let versionKey in singlePlotPvalues){
                        for (let plotValue in singlePlotPvalues[versionKey]){
                            if (plotValue in dataDict[plotKey]){
                                
                                dataDict[plotKey][plotValue][Object.keys(dataDict[plotKey][plotValue])[dataIndex]].reduce((acc: string[], point: any) => {
                                    const subCat = point[plotConfig.barGroupBy?.replace('Sample', 'Sample Title').replace('Treatment', 'Treatment_and_Dose').replace('Channel', 'channel_id') ?? '']
                                    if (!acc.includes(subCat)) {
                                        acc.push(subCat);
                                    }
                                    return acc;
                                }, groupedCategories);
                            }
                        }
                    }
                }
            }
        }
        
        for (let i = 0; i < plotPvaluesArray.length; i++) {
            const dataIndex = i + tileIndex;
            const singlePlotPvalues = plotPvaluesArray[i] as PValueDict;
            const singlePlotErrorBars = plotErrorBarsArray[i] as ErrorBarDict;
            for (let plotKey in dataDict ){    
                for (let versionKey in singlePlotPvalues){
                    for (let plotValue in singlePlotPvalues[versionKey]){
                        if (plotValue in dataDict[plotKey]){
                            
                            let dataCategories: string[] = (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar') ? 
                                groupedCategories:
                                Object.keys(dataDict[plotKey][plotValue]).map((cat) => categoryDict[cat]);
                            // console.log("dataCategories: ", dataCategories);
                            // plotConfig.pvalueControlOptions = dataCategories;
                            if (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar' && !categories.includes(plotConfig.pvalueControl)){
                                plotConfig.pvalueControl = dataCategories[0]
                            }
                            const delta = (1.0 - (plotConfig.bargap ?? 0.2)) / dataCategories.length;

                            const pivot = Math.floor(dataCategories.length / 2);
                            const barToIndex = dataCategories.reduce((acc: Record<string, number>, cat: string, index: number) => {
                                if (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar'){
                                    let offset = index - pivot;
                                    if ((dataCategories.length % 2) === 0) {
                                        offset += 0.5
                                    }
                                    acc[cat] = i + offset * delta; 
                                }
                                else {
                                    acc[cat] = index + indexMod; 
                                }
                                return acc;
                            }, {} as Record<string, number>)

                            for (let pvalueResultIndex in singlePlotPvalues[versionKey][plotValue]){
                                let pvalueResult: PValueDunn | PValueKW | PValueTTest = singlePlotPvalues[versionKey][plotValue][pvalueResultIndex]

                                if (pvalueResult.test === 'kwtest' && plotConfig.showKWResult) {
                                    kwPval = pvalueResult.result.pval
                                    let kwStr =  "Kruskal-Wallis " + getPvalueHoverString(pvalueResult.result.pval, plotConfig)
                                    let annotation = {
                                        ['x']: 1,
                                        ['y']: 1,
                                        xref: `${xAxisString} domain`,
                                        yref: `${yAxisString} domain`,
                                        yanchor: 'top',
                                        xanchor: 'right',
                                        text: kwStr,
                                        showarrow: false
                                    }
                                    annotations.push(annotation)
                                    continue
                                }
                                let pvalue = pvalueResult.result.pval
                                let pvalueStr = getPvalueAnnotationString(pvalue)
                                if (kwPval > 0.05 && pvalueResult.test === 'dunn'){
                                    pvalueStr = '<b>ns</b>'
                                }
                                let control: string = ''
                                let exp: string = ''
                                if (pvalueResult.test == 'ttest' && pvalueResult.mode === 'control'){
                                    control = pvalueResult.control
                                    exp = pvalueResult.exp
                                }
                                else if (pvalueResult.test == 'dunn'){
                                    if (pvalueResult.x === plotConfig.pvalueControl){
                                        control = pvalueResult.x
                                        exp = pvalueResult.y
                                    }
                                    else if (pvalueResult.y === plotConfig.pvalueControl){
                                        control = pvalueResult.y
                                        exp = pvalueResult.x
                                    }
                                    else if (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar' && pvalueResult.x === Object.keys(dataDict[plotKey][plotValue])[0]) {
                                        control = pvalueResult.x
                                        exp = pvalueResult.y
                                    }
                                    else if (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar' && pvalueResult.y === Object.keys(dataDict[plotKey][plotValue])[0]) {
                                        control = pvalueResult.y
                                        exp = pvalueResult.x
                                    }
                                    else { // control is not in dunn test result, skip for now
                                        continue 
                                    }
                                }

                                if (pvalueStr === ''){
                                    continue // if the string is empty, that means there was an issue generating the pvalue
                                }
                                if (plotConfig.pvalueHideInsignificant && pvalueStr.includes('ns') ){
                                    continue
                                }
                                if (!(dataCategories.includes(exp) && dataCategories.includes(control))){
                                    continue
                                } 
                                let values = (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar') ? 
                                    structuredClone(dataDict[plotKey][plotValue][Object.keys(dataDict[plotKey][plotValue])[dataIndex]]).filter((item: any) => item[plotConfig.barGroupBy?.replace('Sample', 'Sample Title').replace('Treatment', 'Treatment_and_Dose').replace('Channel', 'channel_id') ?? ''] === exp).map((item: any) => item.value):
                                    dataDict[plotKey][plotValue][reverseCatDict[exp]].map((item: any) => item.value);
                                let control_values = (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar') ? 
                                    structuredClone(dataDict[plotKey][plotValue][Object.keys(dataDict[plotKey][plotValue])[dataIndex]]).filter((item: any) => item[plotConfig.barGroupBy?.replace('Sample', 'Sample Title').replace('Treatment', 'Treatment_and_Dose').replace('Channel', 'channel_id') ?? ''] === control).map((item: any) => item.value):
                                    dataDict[plotKey][plotValue][reverseCatDict[control]].map((item: any) => item.value);
                                console.log(singlePlotErrorBars)
                                let expError = (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar') ? 
                                    singlePlotErrorBars?.[plotKey][plotValue][Object.keys(dataDict[plotKey][plotValue])[dataIndex]] : 
                                    singlePlotErrorBars?.[plotKey][plotValue][reverseCatDict[exp]];
                                let controlError = (plotConfig.barMode === 'group' && plotConfig.plotType === 'bar') ?
                                    singlePlotErrorBars?.[plotKey][plotValue][Object.keys(dataDict[plotKey][plotValue])[dataIndex]] : 
                                    singlePlotErrorBars?.[plotKey][plotValue][reverseCatDict[control]];


                                let annoY: number = offset
                                let control_annoY: number = offset

                                if (plotConfig.plotType === 'bar'){
                                    let func = Mean;
                                    const mean = func(values);
                                    if (mean < 0) {
                                        annoY = mean - annoY;
                                        control_annoY = func(control_values) - control_annoY;
                                        if (plotConfig.errorBars){
                                            annoY -= expError ? expError : StandardError(values)
                                            control_annoY -= controlError ? controlError : StandardError(control_values)
                                        }
                                    }
                                    else {
                                        annoY += func(values)
                                        control_annoY += func(control_values)
                                        if (plotConfig.errorBars){
                                            annoY += expError ? expError : StandardError(values)
                                            control_annoY += controlError ? controlError : StandardError(control_values)
                                        }    
                                    }
                                    
                                }
                                else if (plotConfig.plotType === 'box'){
                                    annoY += values.reduce((max: any, value:any ) => max > value ? max : value, 0)
                                    control_annoY += control_values.reduce((max:any, value:any) => max > value ? max : value, 0)

                                }
                                else if (plotConfig.plotType === 'scatter'){
                                    annoY += values.reduce((max:any, value:any) => max > value ? max : value, 0)
                                    control_annoY += control_values.reduce((max:any, value:any) => max > value ? max : value, 0)
                                }

                            
                                if (pvalMode === 'lines+text'){
                                    
                                    if (control_annoY > annoY && control_annoY > runningMax){
                                        runningMax = control_annoY
                                    }

                                    if (annoY <= runningMax){
                                        annoY = runningMax
                                    }
                                    else {
                                        runningMax = annoY 

                                    }
                                    
                                    let botBarY = Math.max(annoY, control_annoY, prevTop);
                                    let topBarY = botBarY + (offset);
                                    prevTop = topBarY + (2*offset);
                                    let controlIndex = barToIndex[control];
                                    let expIndex = barToIndex[exp];

                                    let joiner = {
                                        type: 'path',
                                        path: `M ${controlIndex} ${botBarY} V ${topBarY} H ${expIndex} V ${botBarY}`,
                                        line: {
                                            width: 1
                                        },
                                        editable: true,
                                        xref: xAxisString,
                                        yref: yAxisString,
                                    }

                                    let offsetMod: number = 0;
                                    if (pvalueStr !== '<b>ns<b>'){
                                        offsetMod = -0.20
                                    }
                                    let finalY = (plotConfig.yaxis_type !== 'log') ? topBarY + (offset*offsetMod) : Math.log10(topBarY + (offset*offsetMod*2))
                                    let pvalText = {
                                        x: (expIndex + controlIndex)/2 ,
                                        y: finalY,
                                        valign: "bottom",
                                        yanchor:"bottom",
                                        xref: xAxisString,
                                        yref: yAxisString,
                                        borderpad:0,
                                        borderwidth:0,
                                        text: pvalueStr,
                                        showarrow: false,
                                        hovertext: getPvalueHoverString(pvalue, plotConfig) 
                                    }

                                    shapes.push(joiner);
                                    annotations.push(pvalText);
                                    numLines += 1;
                                }
                                else if (pvalMode === 'text'){
                                    let expIndex = barToIndex[exp];
                                    let annotation = {
                                        x: expIndex,
                                        y: annoY,
                                        xref: xAxisString,
                                        yref: yAxisString,
                                        text: pvalueStr,
                                        showarrow: false,
                                        hovertext: getPvalueHoverString(pvalue, plotConfig)
                                    }
                                    annotations.push(annotation);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return { annotations, shapes }
}

const getNumTileRows = (dataLength: number, numTileColumns: number) => {
    return Math.ceil(dataLength / numTileColumns)
}

const getTileRowIndex = (dataIndex: number, dataLength: number, numTileColumns: number) => {
    return dataIndex % getNumTileRows(dataLength, numTileColumns)
};

const getTileColIndex = (dataIndex: number, numTileColumns: number) => {
    return dataIndex % numTileColumns
};

const getDomainForTile = (
  index: number,         // subplot index (row-major order), e.g., 0, 1, 2, ...
  isYAxis: boolean,
  numRows: number,
  numColumns: number,
  gap: number
): [number, number] => {
  const rowIndex = Math.floor(index / numColumns);
  const colIndex = index % numColumns;

//   console.log("numRows: ", numRows);
//   console.log("numRows: ", numRows, " numColumns: ", numColumns, " gap: ", gap, " rowIndex: ", rowIndex, " colIndex: ", colIndex);

//   if (isYAxis) {
//     const subplotHeight = (1 - gap/numRows * (numRows - 1)) / numRows;
//     console.log("subplotHeight: ", subplotHeight);
//     const yStart = 1 - rowIndex * (subplotHeight + gap);
//     // console.log("yStart: ", yStart, " yEnd: ", yStart - subplotHeight);
//     return [yStart - subplotHeight, yStart];
//   } else {
//     const subplotWidth = (1 - gap/numColumns * (numColumns - 1)) / numColumns;
//     const xStart = colIndex * (subplotWidth + gap);
//     return [xStart, xStart + subplotWidth];
//   }
  if (isYAxis) {
    const totalGap = gap * (numRows - 1);
    const subplotHeight = (1 - totalGap) / numRows;
    const yEnd = 1 - rowIndex * (subplotHeight + gap);
    const yStart = yEnd - subplotHeight;
    return [yStart, yEnd];
  } else {
    const totalGap = gap * (numColumns - 1);
    const subplotWidth = (1 - totalGap) / numColumns;
    const xStart = colIndex * (subplotWidth + gap);
    const xEnd = xStart + subplotWidth;
    return [xStart, xEnd];
  }
}

const collapseDataRows = (data: DataRow[]) => {
    // Merge rows with the same top level identifier 
    const newData: DataRow[] = [];
    for (const row of data) {
        // Top level identifiers are "Sample Title", "Treatment_and_Dose", "channel_id", "Timepoint". Merge only if these match
        const topLevelId = `${row['Sample Title']}|${row['Treatment_and_Dose']}|${row['channel_id']}|${row['Timepoint']}`;
        const existingRow = newData.find(r => `${r['Sample Title']}|${r['Treatment_and_Dose']}|${r['channel_id']}|${r['Timepoint']}` === topLevelId);
        if (existingRow) {
            // Merge the values within the version type keys
            for (const key of Object.keys(row)) {
                if (!['Sample Title', 'Treatment_and_Dose', 'channel_id', 'Timepoint'].includes(key)) {
                    if (Array.isArray(row[key]) && Array.isArray(existingRow[key])) {
                        existingRow[key] = existingRow[key].concat(row[key]);
                    }
                }
            }
        }
        else {
            newData.push(row);
        }
    }
    return newData;
}

export const generateProcessedDataList = async (categoryAxes: any, dataAxes: any, filtersState: OldFilterState, plotData: DataRow[], tileState: TileState, axisFiltersState: FilterState, sortOrder: any, activeSampleGroupDict: any,  pathways: Groups, pathwayOrder: number[], pvalueUseRaw?: boolean, groupedModeColumn?: string, heatmapHandleFiltered?: 'rows' | 'columns' | 'keepRows' | 'keepCols' | 'none') => {
    let filteredCategorical = filterCategories(categoryAxes, filtersState)
    let xValues = dataAxes['x'] ? dataAxes['x'] : {}
    let yValues = dataAxes['y'] ? dataAxes['y'] : {}
    let zValues = dataAxes['z'] ? dataAxes['z'] : {}

    let xProcessing = extractDataProcessing(xValues)
    let yProcessing = extractDataProcessing(yValues)
    let zProcessing = extractDataProcessing(zValues)
    
    let isDataVsData = Object.keys(filteredCategorical).length === 0 && (Object.keys(xValues).length > 0 || Object.keys(yValues).length > 0 || Object.keys(zValues).length > 0)

    let trueTiles = tileState ? Object.keys(tileState).filter((key: any) => tileState[key] === true) : []

    let splitTileList = trueTiles.map((tile: any) => {let splitTile = tile.split('|'); return splitTile[0] + '|' + splitTile[1]})

    
    if (!isDataVsData){
        // let dataAxis = Object.keys(dataAxes).find(axis => Object.keys(dataAxes[axis]).length > 0)
        // dataAxis = dataAxis === undefined ? 'y' : dataAxis
        // const dataVersionType = Object.keys(dataAxes[dataAxis] ?? {})?.[0]
        // const dataColumn = dataAxes[dataAxis]?.[dataVersionType]?.values[0]

        // console.time('filterAxis')
        const isPathwayMode = pathways !== undefined && ((xProcessing !== undefined && xProcessing.pathwayMode && xValues) || (yProcessing !== undefined && yProcessing.pathwayMode && yValues) || (zProcessing !== undefined && zProcessing.pathwayMode && zValues));


        const heatmapKeepIfAnyMatchBool = heatmapHandleFiltered === 'keepRows' || heatmapHandleFiltered === 'keepCols';
        const heatmapKeepIfAnyMatchAxis = heatmapHandleFiltered === 'keepRows' ? 'y' : 'x'
        const heatmapKeepIfAnyMatchAxisData =  heatmapKeepIfAnyMatchBool ? categoryAxes[heatmapKeepIfAnyMatchAxis] : undefined

        let updatedPlotData: DataRow[] = filterAxis(axisFiltersState, plotData, 'raw', isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData)
        // console.timeEnd('filterAxis')
        // console.log("updatedPlotData: ", updatedPlotData);
        // console.time('sampleGroupStep')
        updatedPlotData = sampleGroupStep(updatedPlotData, activeSampleGroupDict);
        let rawData = structuredClone(updatedPlotData);
        // console.timeEnd('sampleGroupStep')
        // console.time('normalizeData')
        let {plotData: normalizedData, error: normalizeError} = normalizeData(updatedPlotData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState)
        // console.timeEnd('normalizeData')
        // console.time('aggregateData')
        let aggregatedData = [], aggregationError = '';
        let relativedData = [], relativeError = '';

        const pathwayScore = isPathwayMode ? (xProcessing?.pathwayScore || yProcessing?.pathwayScore || zProcessing?.pathwayScore) : undefined;
        if (pathwayScore == 'ges') {
            const relativeMode = xProcessing?.processingMode === 'relative' || yProcessing?.processingMode === 'relative' || zProcessing?.processingMode === 'relative';
            if (!relativeMode) {
                return { dataList: [], tileTitleList:[], plotError:"GES pathway scoring requires relative processing mode. Please switch to relative mode.", unprocessedDataList:[], xProcessedDataList: null, yProcessedDataList: null, zProcessedDataList: null}
            }
            // in ges mode we need to aggregate and take the relative first before pathway aggregation
            ({plotData: aggregatedData, error: aggregationError} = aggregateData(normalizedData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState, sortOrder));
            ({plotData: relativedData, error: relativeError} = relativeData(aggregatedData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState, isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData));
            relativedData = collapseDataRows(relativedData);
            ({plotData: relativedData, error: relativeError, categories: categoryAxes} = await pathwayData(relativedData, categoryAxes, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, pathways, pathwayOrder));
            if (aggregationError !== undefined && aggregationError !== '') {
                return { dataList: [], tileTitleList:[], plotError:aggregationError, unprocessedDataList:[], xProcessedDataList: null, yProcessedDataList: null, zProcessedDataList: null}
            }
            const geneFilterKey = getFilterKeys(axisFiltersState).find(k => axisFiltersState[k].column === 'Gene' && axisFiltersState[k].type === 'categorical');
            const geneFilterState = geneFilterKey !== undefined ? structuredClone(axisFiltersState[geneFilterKey]) : null;
            if (geneFilterState !== null && axisFiltersState){
                // axisFiltersState = structuredClone(axisFiltersState);
                geneFilterState.value = pathwayOrder.map((k: number) => ({'label':pathways[k].name, 'value': pathways[k].name}))
            }
            filteredCategorical = filterCategories(categoryAxes, filtersState);
        }
        else if (isPathwayMode){
            console.log("relativedData before pathway: ", normalizedData);
            ({plotData: aggregatedData, error: aggregationError, categories: categoryAxes} = await pathwayData(normalizedData, categoryAxes, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, pathways, pathwayOrder))
            if (aggregationError !== undefined && aggregationError !== '') {
                return { dataList: [], tileTitleList:[], plotError:aggregationError, unprocessedDataList:[], xProcessedDataList: null, yProcessedDataList: null, zProcessedDataList: null}
            }
            const geneFilterKey = getFilterKeys(axisFiltersState).find(k => axisFiltersState[k].column === 'Gene' && axisFiltersState[k].type === 'categorical');
            const geneFilterState = geneFilterKey !== undefined ? structuredClone(axisFiltersState[geneFilterKey]) : null;
            if (geneFilterState !== null && axisFiltersState){
                // axisFiltersState = structuredClone(axisFiltersState);
                geneFilterState.value = pathwayOrder.map((k: number) => ({'label':pathways[k].name, 'value': pathways[k].name}))
            }
            filteredCategorical = filterCategories(categoryAxes, filtersState);
            ({plotData: aggregatedData, error: aggregationError} = aggregateData(aggregatedData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState, sortOrder));
            aggregatedData = filterAxis(axisFiltersState, aggregatedData, 'absolute', isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData);
            ({plotData: relativedData, error: relativeError} = relativeData(aggregatedData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState, isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData));
        } 
        else {
            ({plotData: aggregatedData, error: aggregationError} = aggregateData(normalizedData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState, sortOrder));
            aggregatedData = filterAxis(axisFiltersState, aggregatedData, 'absolute', isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData);
            ({plotData: relativedData, error: relativeError} = relativeData(aggregatedData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState, isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData));
            
        }
        // console.timeEnd('aggregateData')
        // console.time('relativeData');
        
        // relativedData = filterAxis(axisFiltersState, relativedData, 'relative', isPathwayMode);
        // console.timeEnd('relativeData');
        // let filteredData: DataRow[] = filterAxis(axisFiltersState, relativedData, 'relative', isPathwayMode);

        // console.log("plotData: ", relativedData);
        // console.time('buildGroupByDict')
        let tileDict = buildGroupByDictGPT(relativedData, splitTileList)
        // console.timeEnd('buildGroupByDict')

        let tileOrder: string[] = Object.keys(tileDict)
        const activeSampleGroupDictOrder = structuredClone(activeSampleGroupDict['ORDER'])
        for (let tileKey of trueTiles) {
            for (let axisItemKey of Object.keys(axisFiltersState)) {
                const axisItem = axisFiltersState[parseInt(axisItemKey)]
                let newString = axisItem.versionType + '|'  + axisItem.column

                if (newString === tileKey) {
                    // tileOrder = axisItem.value.map((item: any) => item.value)
                    let filterIndex = trueTiles.indexOf(newString)
                    let filterOrder = axisItem.value.map((item: any) => item.value)
                    const filterOrderIndexMap = getIndexMapOfStrArray(filterOrder); 
                    tileOrder.sort((a: any, b: any) => filterOrderIndexMap[a.split('|')[filterIndex]] - filterOrderIndexMap[b.split('|')[filterIndex]])
                }
            }
            if ('Sample Group|' === tileKey){
                const sampleGroupOrder = activeSampleGroupDictOrder.map((item: any )=> item.value)
                let filterIndex = trueTiles.indexOf('Sample Group|')
                let filterOrder = sampleGroupOrder
                const filterOrderIndexMap = getIndexMapOfStrArray(filterOrder);
                tileOrder.sort((a: any, b: any) => filterOrderIndexMap[a.split('|')[filterIndex]] - filterOrderIndexMap[b.split('|')[filterIndex]])
            }
            // if (trueTiles.includes('Sample Title|')){
            //     const sampleGroupOrder = activeSampleGroupDictOrder.map((item: any )=> item.value)
            //     tileOrder = sampleGroupOrder
            // }
        }

        // console.log("tileDict: ", tileDict);
        // console.log("tileOrder: ", tileOrder);
        if (tileOrder.length > 200) {
            return { dataList: [], tileTitleList:[], plotError:'Too many items to tile by. Please disable tile mode or narrow the filters.', unprocessedDataList:[], xProcessedDataList: null, yProcessedDataList: null, zProcessedDataList: null}
        }
        console.time('generateCategoricalPlotDataDict')

        let dataList = generateCategoricalPlotDataDict(xValues, yValues, zValues, filteredCategorical, plotData, true, axisFiltersState, tileDict, tileOrder, activeSampleGroupDictOrder, groupedModeColumn)
        console.timeEnd('generateCategoricalPlotDataDict')
        // console.log("dataList: ", dataList);
        // console.time('unprocessedDataList')
        
        let unprocessedDataList = null;
        let unprocessedTileDict = null;
        if (pvalueUseRaw != undefined && pvalueUseRaw !== false) {
            let rawAggData = structuredClone(rawData);
            let rawAggErr = '';
            if (isPathwayMode){
                ({plotData: rawAggData, error: aggregationError, categories: categoryAxes} = await pathwayData(rawAggData, categoryAxes, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, pathways, pathwayOrder));
            }
            ({plotData: rawAggData, error: rawAggErr} = aggregateData(rawAggData, xValues, {...xProcessing, processingMode: 'absolute' }, yValues, {...yProcessing, processingMode: 'absolute' }, zValues, {...zProcessing, processingMode: 'absolute' }, axisFiltersState, sortOrder));
            unprocessedTileDict = (pvalueUseRaw) ? buildGroupByDictGPT(rawAggData, splitTileList) : null
            unprocessedDataList = (pvalueUseRaw) ? generateCategoricalPlotDataDict(xValues, yValues, zValues, filteredCategorical, rawAggData, true, axisFiltersState, unprocessedTileDict, tileOrder, groupedModeColumn) : null
        }

        
        // console.timeEnd('unprocessedDataList')
        // console.log("unprocessedDataList: ", unprocessedDataList);  

        let plotError = '';
        if (normalizeError !== '') {
            plotError = normalizeError;
        }
        else if (aggregationError !== '') {
            plotError = aggregationError;
        }
        else if (relativeError !== '') {
            plotError = relativeError;
        }
    
        let tileTitleList = (tileOrder && tileOrder.length > 0) ? tileOrder : Object.keys(tileDict).map((data: any) => data)
        return { dataList, tileTitleList, plotError, unprocessedDataList, xProcessedDataList: null, yProcessedDataList: null, zProcessedDataList: null}

    }
    else {
        let {plotData: normalizedData, error: normalizeError} = normalizeData(plotData, xValues, xProcessing, yValues, yProcessing, zValues, zProcessing, axisFiltersState)

        let sortOrder: string[] = [];
        let errorString = ''
        let filteredXPlotData = filterAxis(axisFiltersState, normalizedData, 'raw');
        let filteredYPlotData = structuredClone(filteredXPlotData);
        let filteredZPlotData = filterAxis(axisFiltersState, normalizedData, 'raw'); // KH DOUBLE CHECK IF THIS IS RIGHT!
        

        let {plotData: groupedXPlotData, error: groupXError} = groupPlotData(filteredXPlotData, xProcessing?.groupBy, xValues, undefined, undefined, true, axisFiltersState, 'X-Axis Data', undefined, sortOrder);
        if (groupXError) {
            errorString = groupXError
        }

        let {plotData: groupedYPlotData, error: groupYError} = groupPlotData(filteredYPlotData, yProcessing?.groupBy, yValues, undefined, undefined, true, axisFiltersState, 'Y-Axis Data', undefined, sortOrder);
        if (groupYError) {
            errorString = groupYError
        }

        let {plotData: groupedZPlotData, error: groupZError} = groupPlotData(filteredYPlotData, zProcessing?.groupBy, zValues, undefined, undefined, true, axisFiltersState, 'Z-Axis Data', undefined, sortOrder);
        if (groupZError) {
            errorString = groupZError
        }

        let {plotData: xPlotData, error: relativeXError} = relativeData(groupedXPlotData, xValues, xProcessing, yValues, undefined, zValues, undefined, axisFiltersState)
        let {plotData: yPlotData, error: relativeYError} = relativeData(groupedYPlotData, xValues, undefined, yValues, yProcessing, zValues, undefined, axisFiltersState)
        let {plotData: zPlotData, error: relativeZError} = relativeData(groupedZPlotData, xValues, undefined, yValues, undefined, zValues, zProcessing, axisFiltersState)
        
        return { dataList: null, tileTitleList: [], plotError: errorString, unprocessedDataList: null, xProcessedDataList: xPlotData, yProcessedDataList: yPlotData, zProcessedDataList: zPlotData}
    }

}

export const computeTraceStandardErrors = (dataDict: any, categoryDict: any, plotConfig: PlotConfig, axisCategory?: string) : ErrorBarDict => {
    let errorDict: ErrorBarDict = {};
    let categories = Object.keys(categoryDict);
    if (categoryDict && categories.length > 1) {
        categories = categories.map((cat) => categoryDict[cat]);
    }
    for (let plotKey in dataDict ){
        errorDict[plotKey] = {}
        for (let plotValue in dataDict[plotKey]){
            errorDict[plotKey][plotValue] = {}
            for (let catKey in dataDict[plotKey][plotValue]){
                // for (let catKey in dataDict[plotKey][versionKey]){
                if (axisCategory !== undefined && categoryDict[catKey] !== axisCategory){
                    continue
                }

                if (axisCategory !== undefined && plotConfig.barMode === 'group' && plotConfig.plotType === 'bar' && plotConfig.barGroupBy && plotConfig.barGroupBy !== '') {
                    let newCategory = categoryDict[axisCategory];
                    let points = dataDict[plotKey][plotValue][newCategory];
                    if (points === undefined || points.length === 0) {
                        // console.log("No points found for category: ", newCategory);
                        continue;
                    }
                    let groupDict: Record<string, number[]> = {};
                    points.forEach((point: any) => {
                        if (plotConfig.barGroupBy !== undefined) {
                            let groupKey = point[plotConfig.barGroupBy.replace('Sample', 'Sample Title').replace('Treatment', 'Treatment_and_Dose').replace('Channel', 'channel_id').replace('Timepoint', 'Timepoint')];
                            if (!(groupKey in groupDict)) {
                                groupDict[groupKey] = [];
                            }
                            groupDict[groupKey].push(point.value);
                        }
                    });
                    for (let groupKey in groupDict) {
                        errorDict[plotKey][plotValue][groupKey] = StandardError(groupDict[groupKey]);    
                    }
                    // plotConfig.pvalueControl = Object.keys(catDict)[0]
                    // catDict[newCategory] = values
    
                }
                else {
                    let newCategory = categoryDict[catKey]
                    let vals = dataDict[plotKey][plotValue][catKey].map((item: any) => item.value)
                    let stdErr = StandardError(vals);
                    errorDict[plotKey][plotValue][catKey] = stdErr
                }
                // }
            }
        }
    }
    return errorDict
}

export const computeTraceBootstrapedError = async (dataDict: any, categoryDict: any, plotConfig: PlotConfig, axisCategory?: string, aggMethod?: string, func?: string): Promise<ErrorBarDict> => {
    let errorBarDict: any = undefined
    for (let plotKey in dataDict) {
        
        for (let plotValue in dataDict[plotKey]) {
            let catDict: Record<string, number[]> = {}
            if (errorBarDict === undefined) {
                errorBarDict = {}
            }
            if (!(plotKey in errorBarDict)) {
                errorBarDict[plotKey] = {}
            }
            if (!(plotValue in errorBarDict[plotKey])) {
                errorBarDict[plotKey][plotValue] = {}
            }
            if (axisCategory !== undefined && plotConfig.barMode === 'group' && plotConfig.plotType === 'bar' && plotConfig.barGroupBy && plotConfig.barGroupBy !== '') {
                let newCategory = categoryDict[axisCategory];
                let points = dataDict[plotKey][plotValue][newCategory];
                if (points === undefined || points.length === 0) {
                    // console.log("No points found for category: ", newCategory);
                    continue;
                }
                points.forEach((point: any) => {
                    if (plotConfig.barGroupBy !== undefined) {
                        let groupKey = point[plotConfig.barGroupBy.replace('Sample', 'Sample Title').replace('Treatment', 'Treatment_and_Dose').replace('Channel', 'channel_id').replace('Timepoint', 'Timepoint')];
                        if (!catDict[groupKey]) {
                            catDict[groupKey] = [];
                        }
                        catDict[groupKey].push(point.value);
                    }
                });
                // plotConfig.pvalueControl = Object.keys(catDict)[0]
                // catDict[newCategory] = values

            }
            else {
                for (let category in dataDict[plotKey][plotValue]) {
                    let newCategory = categoryDict[category]
                    let values = dataDict[plotKey][plotValue][category].map((item: any) => item.value)
                    catDict[newCategory] = values
                }
            }
            
            // console.log("Cat dict (meow)", catDict)
            let data: any = {
                'data':catDict,
                'operation':{
                    'name':'bootstrap',
                    'control':(Object.keys(catDict).includes(plotConfig.pvalueControl ?? ''))  ? plotConfig.pvalueControl : Object.keys(catDict)[0],
                    'percentile':95,
                    'agg': aggMethod ?? 'mean',
                    'func': func ?? 'percentage_delta',
                }
            }
            try {
                const response: ErrorBarResult[] = (await axios.post(`/tumors/api/v1/stats`, data, {headers: {"X-CSRFToken": getCookie("csrftoken")}})).data
                const reverseCategoryDict = Object.fromEntries(
                    Object.entries(categoryDict).map(([key, value]) => [value, key])
                  );
                for (let res of response) {
                    if (res.exp in catDict) {
                        errorBarDict[plotKey][plotValue][reverseCategoryDict[res.exp]] = res.error
                    }
                }
            } catch (err: any) {
                if (err.response) {
                    console.log("err.response", err.response)
                    if (err.response.status === 403) {
                        window.location.href = '/accounts/login/?next=' + encodeURIComponent(window.location.pathname + window.location.search);
                    } else {
                        console.log(err);
                    }
                } 
                else {
                    console.log(err)
                }
            }
            

        }
    }
    return errorBarDict 
}

export const computeErrorBars = async (processedDataList: any, unprocessedDataList: any, config: PlotConfig, dataAxes: any) : Promise<ErrorBarDict[] | ErrorBarDict[][]> => {
    let outErrors: ErrorBarDict[] | ErrorBarDict[][] = [];
    let xValues = dataAxes['x'] ? dataAxes['x'] : {}
    let yValues = dataAxes['y'] ? dataAxes['y'] : {}
    let zValues = dataAxes['z'] ? dataAxes['z'] : {}
    
    let xProcessing = extractDataProcessing(xValues)
    let yProcessing = extractDataProcessing(yValues)
    let zProcessing = extractDataProcessing(zValues)

    let isRelativeProcessing = (xProcessing !== undefined && xProcessing.processingMode === 'relative') || (yProcessing !== undefined && yProcessing.processingMode === 'relative') || (zProcessing !== undefined && zProcessing.processingMode === 'relative')
    let aggMethod = xProcessing?.aggregationMethod ?? yProcessing?.aggregationMethod ?? zProcessing?.aggregationMethod ?? 'mean';
    
    let func = xProcessing?.relativeUnits ?? yProcessing?.relativeUnits ?? zProcessing?.relativeUnits ?? 'percentage_delta';
    if (config.errorBars && config.plotType === 'bar')  {
        let dataList = (false) ? processedDataList : unprocessedDataList; // forced use raw to always be true for now
        let tIndex = 0;

        for (let dataListElement of dataList){
            let { dataDict, categoryDict } = dataListElement;
            let categories = Object.keys(categoryDict);

            if (categoryDict && categories.length > 1) {
                categories = categories.map((cat) => categoryDict[cat]);
            }

            if (categories.length > 0) {
                if (config.barMode === 'group' && config.plotType === 'bar'){
                    let groupErrors: ErrorBarDict[] = []
                    let groupIndex = 0;
                    for (let axisCategory of categories) {
                        if (isRelativeProcessing) { 
                            groupErrors[groupIndex] = await computeTraceBootstrapedError(dataDict, categoryDict, config, axisCategory, aggMethod, func);
                        }
                        else {
                            groupErrors[groupIndex] = computeTraceStandardErrors(dataDict, categoryDict, config, axisCategory);
                        }
                        groupIndex += 1;
                    }
                    outErrors[tIndex] = groupErrors;
                }
                else {
                    if (isRelativeProcessing) { 
                        outErrors[tIndex] = await computeTraceBootstrapedError(dataDict, categoryDict, config, undefined, aggMethod, func);
                    }
                    else {
                        outErrors[tIndex] = computeTraceStandardErrors(dataDict, categoryDict, config);
                    }
                }
            } else {
                outErrors[tIndex] = {};
            }
            tIndex += 1
        }

    } else {
       return []
    }
    return outErrors
}


export const computePlotPValues = async (proessedDataList: any, unprocessedDataList: any, config: PlotConfig, ) : Promise<PValueDict[] | PValueDict[][]> => {
    
    // const { categories: categoryAxes, data: dataAxes } = processedItems[plotIndex];
    let outPValues: PValueDict[] | PValueDict[][] = [];
    if (config.pvalue === 'control' && config.barMode !== 'stack')  {

        let dataList = (false) ? proessedDataList : unprocessedDataList; // Forced use raw to always be true for now
        let tIndex = 0;

        for (let dataListElement of dataList){
            let { dataDict, categoryDict } = dataListElement;
            let categories = Object.keys(categoryDict);

            if (categoryDict && categories.length > 1) {
                categories = categories.map((cat) => categoryDict[cat]);
            }

            if (config.pvalueControl !== undefined && (categories.includes(config.pvalueControl)  || (config.barMode === 'group' && config.plotType === 'bar'))) {
                if (config.barMode === 'group' && config.plotType === 'bar'){
                    let groupPvals: PValueDict[] = []
                    let groupIndex = 0;
                    for (let axisCategory of categories) {
                        groupPvals[groupIndex] = await generateTracePvalues(dataDict, categoryDict, config, axisCategory);
                        groupIndex += 1;
                    }
                    outPValues[tIndex] = groupPvals;
                }
                else {
                    outPValues[tIndex] = await generateTracePvalues(dataDict, categoryDict, config);
                }
            } else {
                // Default to first trace if control is undefined or categories does not include negative control
                const tempPlotConfig = config;
                tempPlotConfig.pvalueControl = categories[0];
                outPValues[tIndex] = await generateTracePvalues(dataDict, categoryDict, config); 
            }
            tIndex += 1
        }

    } else {
       return []
    }
    return outPValues
};

export const getAutoTitle = (axisItems: AxisItem[]) => {
    let title = '';
    if (axisItems.length > 0) {
        const axisItem = axisItems[0]
        if (axisItems[0].method !== 'data') {
            return '';
        }
        const dataName = axisItem.values.join(' + ').replace('_', ' ') || '';
        if (axisItem.processingMode === 'relative') {
            const relativeUnitMap: Record<string, string> = {
                percentage_delta: "% Delta", 
                fold_change: "Fold Change",
                log2_fold_change: "Log2(FC)",
                log2_fold_change_smooth: "Log2(FC) Smooth",
                delta: "Delta",
                percentage: "%",
              }
            const relativeMethod = relativeUnitMap[axisItem.relativeUnits ?? ''] ?? axisItem.relativeUnits;

            const reference = axisItem.references?.map(r => {
                return r.value.value.replace("Media: 0 µg/mL", "Media")
            }).join(', ')
            title = ` ${dataName} (${relativeMethod} relative to ${reference})`;
        }   
        else {
            title = dataName;
        }
    }
    return title;
}

export const updatePlotLayout = (minmax_values: any, dataList: any, plotConfig: PlotConfig, plotPvaluesList: PValueDict[] | PValueDict[][], plotErrorBars: ErrorBarDict[] | ErrorBarDict[][] ,  tileTitleList: any, setNumTileColumns: (cols: number) => void, tileSharedY: boolean, tileSharedX: boolean, selectedItems: SelectedItems) => {

    let _xmin = plotConfig.xmin;
    let _xmax = plotConfig.xmax;
    let _ymin = plotConfig.ymin;
    let _ymax = plotConfig.ymax; 

    const bargap = plotConfig.bargap ?? 0.2;

    if (plotConfig.xaxis_type === 'log'){
    if (_xmin !== null) 
        _xmin = Math.log10(_xmin);
    if (_xmax !== null) 
        _xmax = Math.log10(_xmax);
    }

    if (plotConfig.yaxis_type === 'log'){
        if (!Number.isNaN(_ymin)) {
            _ymin = Math.log10(_ymin ? _ymin : 0);
        }
        if (!Number.isNaN(_ymax)) {
            _ymax = Math.log10(_ymax ? _ymax : 0);
        }
    }

    let autorangey: boolean | string | undefined = true;
    let autorangex: boolean | string | undefined = true;

    // Set different x and y ranges if relative mode is specified
    if (selectedItems) {
        if (selectedItems['X-Axis Data']?.[0]?.processingMode === 'relative') {
            _xmin = plotConfig.xmin_rel;
            _xmax = plotConfig.xmax_rel;
        } else {
            _xmin = plotConfig.xmin;
            _xmax = plotConfig.xmax;
        }

        if (selectedItems['Y-Axis Data']?.[0]?.processingMode === 'relative') {
            _ymin = plotConfig.ymin_rel;
            _ymax = plotConfig.ymax_rel;
        } else {
            _ymin = plotConfig.ymin;
            _ymax = plotConfig.ymax;
        }
    }

    // X-axis autorange logic
    if (_xmin == null && _xmax == null) {
        autorangex = true;
    } else {
        if (_xmin == null) {
            _xmin = minmax_values.x.min;
            const xrange = _xmax! - _xmin!;
            const buffer = xrange * 0.2;
            _xmin = _xmin! - buffer;
        }
        if (_xmax == null) {
            _xmax = minmax_values.x.max;
            const xrange = _xmax! - _xmin!;
            const buffer = xrange * 0.2;
            _xmax = _xmax! + buffer;
        }
        autorangex = false;
    }

    // Y-axis autorange logic
    if (_ymin == null && _ymax == null) {
        autorangey = true;
    } else {
        if (_ymin == null) {
            _ymin = minmax_values.y.min;
            const yrange = _ymax! - _ymin!;
            const buffer = yrange * 0.2;
            _ymin = _ymin! - buffer;
        }
        if (_ymax == null) {
            _ymax = minmax_values.y.max;
            const yrange = _ymax! - _ymin!;
            const buffer = yrange * 0.2;
            _ymax = _ymax! + buffer;
        }
        autorangey = false;
    }

    let tileAnnotations: any[] = []
    let tileShapes: any[] = []

    const adjustAnnotationsForTiling = (
        annotations: any[],
        col: number,
        row: number,
        xAxis: number,
        yAxis: number,
        tileSharedX: boolean,
        tileSharedY: boolean,
        numTileRows: number,
        numTileColumns: number,
    ): any[] => {
        return annotations
            .filter((a) => {
                if (a.type === 'text-caption') {
                    // Only include caption on bottom-left subplot
                    return row === numTileRows - 1 && col === 0;
                }
                // Only include plot or paper text
                return a.type === 'text-plot' || a.type === 'text-paper';
            })
            .map((a) => {
                const isXPaper = a.xref === 'paper';
                const isYPaper = a.yref === 'paper';

                let xref: string;
                let yref: string;

                if (a.type === 'text-caption') {
                    // don't reset anything for caption; xref and yref should already be set to paper
                    xref = a.xref;
                    yref = a.yref;
                } else {
                    // xref
                    if (isXPaper) {
                    xref = tileSharedX
                        ? col === 0 ? 'x domain' : `x${col + 1} domain`
                        : `x${xAxis} domain`;
                    } else {
                    xref = tileSharedX
                        ? col === 0 ? 'x' : `x${col + 1}`
                        : `x${xAxis}`;
                    }

                    // yref
                    yref = isYPaper ? `y${yAxis} domain` : `y${yAxis}`;
                }

                return {
                    ...a,
                    xref,
                    yref,
                };
            });
        };


    const adjustShapesForTiling = (
        shapes: any[],
        col: number,
        row: number,
        xAxis: number,
        yAxis: number,
        tileSharedX: boolean,
        tileSharedY: boolean
        ): any[] => {
        return shapes
            .filter((s) => s.type === 'line')
            .map((s) => {
                const isXPaper = s.xref === 'paper';
                const isYPaper = s.yref === 'paper';
                let xref: string;
                let yref: string;

                if (isXPaper) {
                    if (tileSharedX) {
                        xref = col === 0 ? 'x domain' : `x${col + 1} domain`;
                    } else {
                        xref = `x${xAxis} domain`;    
                    }
                } else {
                    if (tileSharedX) {
                        xref = col === 0 ? 'x' : `x${col + 1}`;
                    } else {
                        xref = `x${xAxis}`;    
                    }
                }

                if (isYPaper) {
                    yref = `y${yAxis} domain`;    
                } else {
                    yref = `y${yAxis}`;    
                }

                return {
                    ...s,
                    xref,
                    yref,
                };
            });
    };

    let tileTitles = tileTitleList;
    let numTileTitles = tileTitles.length;
    let tileRows = 1;
    let tileColumns = 1;
    if (tileTitleList.length > 1) {
            
        if (plotConfig.tileMode === 'fixedRow') {
            tileRows = plotConfig.tileFixedRowCount ?? 1;
            tileColumns = Math.ceil(numTileTitles / tileRows);
        }
        else if (plotConfig.tileMode === 'fixedColumn') {
            tileColumns = plotConfig.tileFixedColumnCount ?? 1;
            tileRows = Math.ceil(numTileTitles / tileColumns);
        }
        else if (plotConfig.tileMode === 'autoGrid') {
            // set the columns and rows minimize the amount of empty plots in the grid
            const factors = (num: number) => [...Array(num + 1).keys()].filter(i=>num % i === 0);
            
            const findSquarestFactorPair = (n: number) => {
                const tileFactors = factors(n);
                if (tileFactors.length === 2) { // Prime Number
                    // Add one extra plot to make it not a single row
                    ({tileRows, tileColumns} = findSquarestFactorPair(n + 1));
                }
                else if (tileFactors.length % 2 === 0) { // Even number of factors
                    tileColumns = tileFactors[(tileFactors.length / 2)];
                    tileRows = tileFactors[(tileFactors.length / 2) - 1];
                }
                else { // Odd number of factors (square number)
                    tileColumns = tileFactors[Math.floor(tileFactors.length / 2)];
                    tileRows = tileColumns;
                }
                return {tileRows, tileColumns};
            };
            ({tileRows, tileColumns} = findSquarestFactorPair(numTileTitles));
        
        }
    }
    setNumTileColumns(tileColumns);
    // console.log(plotConfig.pvalue, plotConfig.pvalueControl, plotConfig.plotType, plotPvalues)
    if (plotConfig.pvalue && plotConfig.pvalue === 'control' && plotConfig.pvalueControl !== undefined && plotPvaluesList && plotConfig.plotType !== 'heatmap' && dataList !== null){

        const rowMaxAndMins: {max:number, min:number}[] = []
        for (let row = 0; row < tileRows; row++){
            let rowMax = 0;
            let rowMin = undefined;
            for (let index in dataList){
                let {dataDict, categoryDict} = dataList[index]
                if (plotConfig.ymax !== undefined && plotConfig.ymin !== undefined && plotConfig.ymax !== null && plotConfig.ymin !== null){
                    rowMax = plotConfig.ymax
                    rowMin = plotConfig.ymin
                    break
                }
                else {
                    for (let plotKey in dataDict ){    
                        for (let versionKey in dataDict[plotKey]){
                            for (let categorical in dataDict[plotKey][versionKey]){
                                let values = dataDict[plotKey][versionKey][categorical].map((item: any) => item.value)
                                let localMax = values.reduce((max:any, value:any) => max > value ? max : value, 0)
                                let localMin = values.reduce((min:any, value:any) => min < value ? min : value, localMax)
                                if (plotConfig.plotType === 'bar'){
                                    localMax = Mean(values) > 0 ? Mean(values) : 0
                                    localMin = localMax === 0 ? Mean(values) : 0 
                                }
                                if (localMax > rowMax){
                                    rowMax = localMax
                                }
                                if (rowMin === undefined || localMin < rowMin){
                                    rowMin = localMin
                                }
            
                            }
                        }
                    }
                }
            }
            rowMaxAndMins[row] = {max: rowMax, min: rowMin}
        }

        for (let index in dataList) {
            let indexInt = parseInt(index);
            let {dataDict, categoryDict} = dataList[index];
            const row = getTileRowIndex(indexInt, dataList.length, tileColumns);
            const col = getTileColIndex(indexInt, tileColumns);
            let xAxis = indexInt + 1;
            let yAxis = indexInt + 1;
            let {max, min} = rowMaxAndMins[row];
            let {annotations, shapes} = generatePvalueAnnotations(plotPvaluesList[indexInt], dataDict, categoryDict, plotConfig, xAxis, yAxis, max, min, indexInt, plotErrorBars[indexInt]);


            if (dataList.length === 1) {
                annotations.push(...plotConfig.annotations);
                shapes.push(...plotConfig.shapes);
            } else {
                annotations.push(...adjustAnnotationsForTiling(plotConfig.annotations, col, row, xAxis, yAxis, tileSharedX, tileSharedY, tileRows, tileColumns));
                shapes.push(...adjustShapesForTiling(plotConfig.shapes, col, row, xAxis, yAxis, tileSharedX, tileSharedY));
            }

            tileAnnotations = tileAnnotations.concat(annotations);
            tileShapes = tileShapes.concat(shapes);
        }


        let pvalueInfo = {
            x: 1.00,
            y: 0,
            xref: 'paper',
            yref: 'paper',
            text: '<b>ns</b> p >   0.05<br><b>   *</b> p <= 0.05 <br><b>  **</b> p <= 0.01  <br><b> ***</b> p <= 0.001 <br><b>****</b> p <= 0.0001', 
            showarrow: false,
            xanchor:'right',
            bgcolor: 'white'
        }
        if (plotConfig.pvalueLegend) {
            tileAnnotations.push(pvalueInfo)
        }
    } else if (plotConfig.plotType !== 'heatmap' && dataList !== null) {

        for (let index in dataList) {
            let indexInt = parseInt(index);
            let {dataDict, categoryDict} = dataList[index];
            const row = getTileRowIndex(indexInt, dataList.length, tileColumns);
            const col = getTileColIndex(indexInt, tileColumns);
            let xAxis = indexInt + 1;
            let yAxis = indexInt + 1;
            let annotations = [];
            let shapes = [];
            
            if (dataList.length === 1) { // No Tiling
                annotations.push(...plotConfig.annotations);
                // shapes.push(...adjustShapesForTilingMutateInPlace(plotConfig.shapes, col, row, xAxis, yAxis, tileSharedX, tileSharedY));
                shapes.push(...plotConfig.shapes);
            } else {
                annotations.push(...adjustAnnotationsForTiling(plotConfig.annotations, col, row, xAxis, yAxis, tileSharedX, tileSharedY, tileRows, tileColumns));
                shapes.push(...adjustShapesForTiling(plotConfig.shapes, col, row, xAxis, yAxis, tileSharedX, tileSharedY));
                // shapes.push(...adjustShapesForTilingMutateInPlace(plotConfig.shapes, col, row, xAxis, yAxis, tileSharedX, tileSharedY));
            }
                        
            tileAnnotations = tileAnnotations.concat(annotations);
            tileShapes = tileShapes.concat(shapes);
        }

    }

    // if (plotConfig.plotType === 'box'){
    //     let filteredCategorical = filterCategories(categoryAxes, filtersState)

    //     let xValues = dataAxes['x'] ? dataAxes['x'] : {}
    //     let yValues = dataAxes['y'] ? dataAxes['y'] : {}
    //     let zValues = dataAxes['z'] ? dataAxes['z'] : {}
    //     let {dataDict, categoryDict} = generateCategoricalPlotDataDict(xValues, yValues, zValues, filteredCategorical, plotData, plotConfig, true)

    //     for (let plotKey in dataDict) {
    //         for (let plotValue in dataDict[plotKey]) {
    //             // Now loop through categories and create separate traces
    //             let index = 0
    //             for (let category in dataDict[plotKey][plotValue]) {
    //                 let values = dataDict[plotKey][plotValue][category].map((item: any) => item.value)
    //                 let max = values.reduce((max, value) => max > value ? max : value, 0)
    //                 let min = values.reduce((min, value) => min < value ? min : value, max)
    //                 let rect = {
    //                     type:'rect',
    //                     x0: index-.25,
    //                     y0: max,
    //                     x1: index+0.25,
    //                     y1: min,
    //                     fillcolor: 'black',
    //                     opacity:0.5,
    //                     hovertext: "Testestest"

    //                 }
    //                 shapes.push(rect)
    //                 index += 1
    //             }
    //         }
    //     }
    // }

    let newPlotLayout: any = {
        title: {text: plotConfig.showTitle ? plotConfig.title : '', y: .99, x: .5},
        titlefont: {
            size: plotConfig.titleFontSize,
            // family: 'Arial, sans-serif',
        },
        showlegend: plotConfig.showLegend,
        hovermode: 'closest',
        font: {
            size: plotConfig.fontSize,
            // family: 'Arial, sans-serif',
        },
        plot_bgcolor: plotConfig.plot_bgcolor,
        paper_bgcolor: "white",
        annotations: tileAnnotations,
        shapes: tileShapes,
        autoMargin: false,
        margin: {t: 100, l: 0, r: 0, b: 50},
        barmode: plotConfig.barMode === 'none' ? undefined : plotConfig.barMode,
        barnorm: plotConfig.barMode === 'relative' ? 'percent' : undefined,
        bargap: plotConfig.bargap,
    };

    const createAxisConfig = (axisType: 'x' | 'y', index: number, rows: number, columns: number, showLabels: boolean, showLegend: boolean) => {
        // console.log("Index", index)
        let isBottomRow = Math.ceil(index / columns) === rows || (index + columns) > numTileTitles; 
        let isLeftColumn = (columns === 1 || index % columns === 1);


        let axisRange = axisType === 'y' ? (Number.isNaN(_ymin) && Number.isNaN(_ymax)) ?  undefined : [Number.isNaN(_ymin) ? null : _ymin, Number.isNaN(_ymax) ? null : _ymax] : (Number.isNaN(_xmin) && Number.isNaN(_xmax)) ?  undefined : [Number.isNaN(_xmin) ? null : _xmin, Number.isNaN(_xmax) ? null : _xmax] 

        let showLabelsFinal = showLabels;

        if ((axisType === 'x') && (showLabelsFinal)) {
            // Only show xlabels on bottom row
            showLabelsFinal = tileSharedX ? isBottomRow : true;
        }    

        if ((axisType === 'y') && (showLabelsFinal) && (rows > 1 || columns > 1)) {
            // Only show y tick labels on left hand axis when tileSharedY is on
            showLabelsFinal = tileSharedY ? isLeftColumn : true;
        }

        // DEBUG
        // console.log("axisType: ", axisType);
        // console.log("axisRange: ", axisRange);
        // console.log("autorangex: ", autorangex);
        // console.log("autorangey: ", autorangey);

        let newAxisConfig =  {
            title: '',
            type: plotConfig[`${axisType}axis_type`] || 'lin',
            showgrid: plotConfig[`${axisType}axis_showgrid`],
            showline: plotConfig[`${axisType}axis_showline`],
            zeroline: true,
            gridcolor: plotConfig["gridline_color"] ,
            linecolor: plotConfig["axis_linecolor"],
            showticklabels:showLabelsFinal,
            zerolinecolor: "white",
            automargin: true,
            zerolinewidth: 2,
            tickfont: {
                size: axisType === 'x' ? plotConfig.xAxisLabelFontSize : plotConfig.yAxisLabelFontSize
            },
            titlefont: {
                size: axisType === 'x' ?  plotConfig.xAxisTitleFontSize : plotConfig.yAxisTitleFontSize
            },
            autorange: axisType === 'y' ? autorangey : autorangex,
            range: axisRange,
            // tickmode: axisType == 'x' ? 'array' : 'auto',  // TO DO - only set this if the plot type is a box plot with points enabled
            
        };

        if (index === 1) {
            let axisTitle = '';
            if (axisType === 'x') {
                axisTitle = (plotConfig.xaxis_autotitle) ? getAutoTitle(selectedItems['X-Axis Data']): plotConfig.xtitle || '';
            } else if (axisType === 'y') {
                axisTitle = (plotConfig.yaxis_autotitle) ? getAutoTitle(selectedItems['Y-Axis Data']): plotConfig.ytitle || '';
            }
            newAxisConfig['title'] = axisTitle;
        }

        return newAxisConfig;
    };

    if (numTileTitles > 1) {
        
        newPlotLayout['grid'] = { 
            rows: tileRows, 
            columns: tileColumns, 
            pattern: 'independent',
            roworder: 'top to bottom',
            xgap: plotConfig.subplotXgap, //0.1
            ygap: plotConfig.subplotYgap, //0.13
        };
        
        let rowYAxisMapping = new Array(tileRows).fill(null);
        let colXAxisMapping = new Array(tileColumns).fill(null);

        for (let i = 0; i < tileRows * tileColumns; i++) {
            let axisSuffix = i === 0 ? '' : `${i+1}`;  // Adjust suffix to start from 1 after the first index
            let currentRow = Math.floor(i / tileColumns); 
            let currentCol = i - (currentRow *  tileColumns); 

            // X-axis config
            newPlotLayout[`xaxis${axisSuffix}`] = createAxisConfig('x', i + 1, tileRows, tileColumns, plotConfig.showXtickLabels, true);
            // Explicitly define domain extent to control gaps between rows and cols
            newPlotLayout[`xaxis${axisSuffix}`].domain = getDomainForTile(i, false, tileRows, tileColumns, plotConfig.subplotXgap);


            // Y-Axis config
            newPlotLayout[`yaxis${axisSuffix}`] = createAxisConfig('y', i + 1, tileRows, tileColumns, plotConfig.showYtickLabels, true);
            // Explicitly define domain extent to control gaps between rows and cols
            newPlotLayout[`yaxis${axisSuffix}`].domain = getDomainForTile(i, true, tileRows, tileColumns, plotConfig.subplotYgap);


            if (tileSharedY) {    
                if (rowYAxisMapping[currentRow] === null) {
                    rowYAxisMapping[currentRow] = `y${axisSuffix}`;
                } else {
                    newPlotLayout[`yaxis${axisSuffix}`].matches = rowYAxisMapping[currentRow];
                }
            } 
            if (tileSharedX) {    
                if (colXAxisMapping[currentCol] === null) {
                    colXAxisMapping[currentCol] = `x${axisSuffix}`;
                } else {
                    newPlotLayout[`xaxis${axisSuffix}`].matches = colXAxisMapping[currentCol];
                }
            } 

            if (i < tileTitles.length) {
                let currentRow = Math.floor(i / tileColumns);
                let [_, yEnd] = getDomainForTile(i, true, tileRows, tileColumns, plotConfig.subplotYgap);
                let annotationYPosition = yEnd;


                newPlotLayout.annotations.push({
                    x: ((i % tileColumns) + 0.5) / tileColumns, // Normalize x position over the grid
                    y: annotationYPosition, // Adjust y position based on the row
                    xref: 'paper',
                    yref: 'paper',
                    xanchor: 'center',
                    yanchor: 'bottom', // Aligns the text to the top of the plot
                    text: plotConfig.showTileTitles ? tileTitles[i] : '',
                    showarrow: false,
                    font: {
                        size: 16,
                        color: 'black'
                    }
                });
            }

        }
    } else {
        let yaxis = createAxisConfig('y', 1, 1, 1, plotConfig.showYtickLabels, true);
        let xaxis = createAxisConfig('x', 1, 1, 1, plotConfig.showXtickLabels, true);
        newPlotLayout['xaxis'] = xaxis
        newPlotLayout['yaxis'] = yaxis
    }

    return newPlotLayout;
}

export const setBoxPlotTicks = (layout: any, traces: any, plotConfig: PlotConfig, tileState: TileState, colorOverrideMap: Record<string, string>) => {

    // console.log("plotConfig: ", plotConfig);

    // KH 9/25/24: Update the layout and traces to contain explicit tick labels and values corresponding with the traces on a box plot
    // Necessary for the customized support for box plots with points (can't use 'boxpoints' parameter as the functionality 
    // accessing and labeling the scatter trace points is limited)

    // KH 10/29/24: refactored to split out separate traces by color by parameter (so that legend works correctly)

    // console.log("plotConfig.scatterColorBy: ", plotConfig.scatterColorBy);

    const addHorizontalJitter = (x: number[], y: number[], maxJitter: number) => {
        const yNoNaN = y.filter(val => !isNaN(val));
        const meanY = yNoNaN.reduce((sum, val) => sum + val, 0) / yNoNaN.length;
        const yRange = Math.max(...yNoNaN) - Math.min(...yNoNaN);
      
        const jitteredX = x.map((xi, i) => {
            if (isNaN(y[i])) {
                return xi;
            }
            const distanceFromMean = Math.abs(y[i] - meanY);
            const jitterScale = 1 - (distanceFromMean / yRange);
            const jitter = ((Math.random() * maxJitter) - maxJitter / 2) * jitterScale;
            return xi + jitter;
        });
        return jitteredX;
    };

    let boxplot_with_points = false;
    for (let trace of traces) {
        if (trace.type === 'box' && trace.boxpoints === 'all') {
            boxplot_with_points = true;
        }
    }
    const extractKeyValues = (text: string): { [key: string]: string } => {
        const keyValuePairs = text.split('<br />');
        const result: { [key: string]: string } = {};
        keyValuePairs.forEach(pair => {
            const [key, ...rest] = pair.split(':').map(part => part.trim());
            const value = pair.replace(key + ':', '').trim();
            if (key && value && key !== 'Value') {
                result[key] = value;
            }
        });
        return result;
    };
    const newTraces: any[] = [];
    const uniqueLabelsMap = new Map<string, any[]>(); 
    
    // Create a Set to store unique colorByKey values
    const uniqueColorByKeys = new Set();
    for (let trace of traces) {
        if (trace.type === 'scatter') {
            const colorByHoverTextKey = plotConfig.scatterColorBy || '';
            const extractedHoverData = trace.hovertext.map((text: string) => extractKeyValues(text));
            const text_labels = extractedHoverData.map((item: any) => item[colorByHoverTextKey]);
            text_labels.forEach((label: any, index: any) => {
                // Add the label to the set of unique labels spanning all scatter traces in the plot
                uniqueColorByKeys.add(label);
            });
        }
    }

    const xaxisTickDict = [];

    if (boxplot_with_points) {
        // First loop through all traces, find those that are scatter traces and set the specified text label
        for (let trace of traces) {
            if (trace.type === 'box' || trace.type === 'bar') { // check if bar too to account for edge case with empty box trace (see generateBoxPlot Line ~2660)
                newTraces.push(trace);
                if (trace.boxpoints === 'all') {
                    trace.boxpoints = false; 
                }
            } 

            if (trace.type === 'scatter') {
                

                const colorByHoverTextKey = plotConfig.scatterColorBy || '';
                // console.log("colorByHoverTextKey: ", colorByHoverTextKey);
                const extractedHoverData = trace.hovertext.map((text: string) => extractKeyValues(text));
                const text_labels = extractedHoverData.map((item: any) => item[colorByHoverTextKey]);

                const jitteredX = addHorizontalJitter(trace.x, trace.y, 0.1);

                text_labels.forEach((label: any, index: any) => {
                    // Add the label to the set of unique labels spanning all scatter traces in the plot
                    uniqueColorByKeys.add(label);

                    if (!uniqueLabelsMap.has(label)) {
                        uniqueLabelsMap.set(label, []);
                    }
                    uniqueLabelsMap.get(label)!.push({
                        x: jitteredX[index],
                        y: trace.y[index],
                        text: plotConfig.scatterShowLabels ? label : undefined,
                        colorByKey: label,
                        hovertext: trace.hovertext[index],
                    });
                });
                // console.log("uniqueLabelsMap: ", uniqueLabelsMap);
            }
        }

        // Now create the color map: assign colors to keys
        // const colorMap = Array.from(uniqueColorByKeys as Set<string>).reduce((acc: Record<string, string>, label, index) => {
        //     // const colorIndex = index % Object.keys(defaultColorMap).length;
        //     // acc[label] = defaultColorMap[colorIndex as keyof typeof defaultColorMap];
        //     // return acc;
        //     const colorIndex = newTraces.length + index; // Need to offset by length of first box traces
        //     acc[label] = plotConfig?.colorMap?.[colorIndex] || 'blue';
        //     return acc; 
        // }, {} as Record<string, string>);


        const uniqueXValues = new Set(newTraces.flatMap(item => item.x));
        // const availableColors = { ...plotConfig.colorMap };
        const overrideColors = new Set(Object.values(colorOverrideMap));
        const includeOverride = overrideColors.size >= Object.values(defaultColorMap).length - 4; 
        const availableColors = (Object.values(defaultColorMap) as string[]).filter(col => !overrideColors.has(col) || includeOverride) as string[];
        // console.log("availableColors: ", availableColors);
        // for (const key in colorOverrideMap) {
        //     if (colorOverrideMap[key]) {
        //         availableColors[key] = colorOverrideMap[key]; // Override the color if it exists in the color map
        //     } 
        // }
        let colorValues = Object.values(availableColors);
        // Exclude the first colors associated with the box plot
        // if (uniqueXValues.size < 6) { // Need this protection since the original colorMap is limited to only ~10 or so colors
        //     colorValues = colorValues.slice(uniqueXValues.size)
        // }
        // console.log("colorValues: ", colorValues);

        // Build the colormap with a cyclic mapping of colors
        const colorMap = Array.from(uniqueColorByKeys as Set<string>)
            .sort() // Optional: Ensures deterministic ordering
            .reduce((acc: Record<string, string>, label, index) => {
                const colorIndex = index % colorValues.length; // Use cyclic indexing

                if (colorOverrideMap && colorOverrideMap[label]) {

                    acc[label] = colorOverrideMap[label]; // Use the overridden color if available
                }
                else {
                    acc[label] = colorValues[colorIndex]; // Fallback color
                }
                return acc;
        }, {});

        uniqueLabelsMap.forEach((dataPoints, label) => {
            const newScatterTrace = {
                type: 'scatter',
                mode: plotConfig.scatterShowLabels ? 'markers+text' : 'markers',
                x: dataPoints.map(point => point.x),
                y: dataPoints.map(point => point.y),
                text: dataPoints.map(point => point.text),
                hovertext: dataPoints.map(point => point.hovertext),
                name: label + " ",  // Distinguish scatter traces with a space at the end of the name (to be used in logic of PlotOptionsModal; may be able to refactor and distinguish based on trace type)
                marker: {
                    color: dataPoints.map(point => colorMap[point.colorByKey]),
                    size: plotConfig.markerSize,
                },
                textposition: plotConfig.scatterShowLabels ? 'top center': undefined,
            };
            newTraces.push(newScatterTrace);
        });

        const xaxes = layout.grid && layout.grid.columns && layout.grid.rows 
            ? Array.from({ length: layout.grid.rows * layout.grid.columns }, (_, i) => `x${i + 1}`) 
            : ['x1'];

        for (const xaxis of xaxes) {
            const traceNames = traces
                .filter((trace: any) => !trace.name.endsWith(' ') && trace.xaxis === xaxis)
                .map((trace: any) => trace.name);

            const ticktext = traceNames.reduce((acc: string[], label: string) => {
                acc.push('');
                const adjustedLabel = label.length > 30 ? label.slice(0, 30) + '...' : label;
                acc.push(adjustedLabel);
                return acc;
            }, []);
            const tickvals = Array.from({ length: ticktext.length }, (_, i) => Math.floor(i / 2) + 1);

            xaxisTickDict.push({ 'xaxis': xaxis, 'ticktext': ticktext, 'tickvals': tickvals });
        }
    }

    const newLayout = { ...layout };
    if (layout.grid && layout.grid.columns && layout.grid.rows) {
        for (let i = 1; i <= (layout.grid.rows * layout.grid.columns); i++) {
            const axisKey = i === 1 ? 'xaxis' : `xaxis${i}`;
            if (newLayout[axisKey]) {
                newLayout[axisKey] = {
                    ...newLayout[axisKey],
                    tickvals: xaxisTickDict.find(x => x.xaxis === `x${i}`)?.tickvals,
                    ticktext: xaxisTickDict.find(x => x.xaxis === `x${i}`)?.ticktext,
                    tickmode: 'array',
                };
            }
        }
    } else {
        newLayout['xaxis'] = {
            ...newLayout['xaxis'],
            tickvals: xaxisTickDict.find(x => x.xaxis === 'x1')?.tickvals,
            ticktext: xaxisTickDict.find(x => x.xaxis === 'x1')?.ticktext,
            tickmode: 'array',
        };
    }


    // Now reorder the traces and assign xaxis and yaxis to the scatter traces
    let finalTraces: any = [];

    let tileByList = Object.entries(tileState)
        .filter(([key, value]) => value) // Filter for entries with a value of true
        .map(([key]) => key.replace(/\|$/, '')); // Strip "|" if it ends with it

    // Replace 'Sample Title' with 'Sample' as this is how it appears in the scatter trace hovertext
    tileByList = tileByList.map(item => item === 'Sample Title' ? 'Sample' : item);
    tileByList = tileByList.map(item => item === 'Treatment_and_Dose' ? 'Treatment' : item);
    
    // Split out only last part that is split by '|':
    tileByList = tileByList.map(item => {
        if (item.includes('|')) {
            const parts = item.split('|');
            return parts[1]; // Return the part after '|'
        } else {
            return item;
        }
    }).filter(Boolean); // Optionally filter out any undefined values
    
    const splitScatterTraces: any[] = [];
    const uniqueTileByValues: Record<string, Set<any>> = {};
    let tileScatterTraceIndex = 0;
    let subplotIndex = 0;

    newTraces.forEach(trace => {
        if (trace.type === 'scatter') {
            // console.log("original scatter trace: ", trace);
            // Build a dict for the hovertext
            const hoverData = trace.hovertext.map((item: any) => {
                const parts = item.split('<br />');                
                const result: any = {};
                parts.forEach((part: string) => {
                    const [key, ...valueParts] = part.split(': ');
                    if (key && valueParts.length > 0) {
                        // Join the remaining parts to preserve the full value - necesary for Treatment_and_Dose syntax with ':'
                        const value = valueParts.join(': ').trim();
                        result[key] = value;
                    }
                });
                
                return result;
            });
            // console.log("hoverData: ", hoverData)

            // Create new traces for each unique hoverData key that is in tileByList
            const uniqueKeys = new Set(hoverData.flatMap((data: any) => Object.keys(data))); // Get unique keys from hoverData

            // Build a new dictionary that maps the key in the tileByList to the unique values in hoverData
            uniqueKeys.forEach((key: any) => {
                if (tileByList.includes(key)) {
                    // Collect unique values for this key from hoverData
                    hoverData.forEach((point: any) => {
                        if (!uniqueTileByValues[key]) {
                            uniqueTileByValues[key] = new Set();
                        }
                        if (point[key]) {
                            uniqueTileByValues[key].add(point[key]); // Add unique value to the set
                        }
                    });
                }
            });
            
            let keyIndex = 0;
            let numberOfItemsInPreviousKeys = 0;
            // for each tile by unique key (i.e. "Gene", "Sample", etc...)
            tileByList.forEach((key: any) => {

                // Check if the key exists in the hoverData for any point to ensure it is in the hoverData object
                const keyExistsInHoverData = hoverData.some((point: any) => key in point);

                if (!keyExistsInHoverData) {
                    console.warn(`Key "${key}" not found in hoverData, skipping.`);
                    return; // Skip this key if not found in hoverData
                }

                // console.log("uniqueTileByValues: ", uniqueTileByValues);
    
                // for each subplot
                Array.from(uniqueTileByValues[key]).forEach((value: any) => {
                    subplotIndex = Array.from(uniqueTileByValues[key]).indexOf(value) + (keyIndex * numberOfItemsInPreviousKeys);
                    // Loop through scatter trace points and find matching hover data
                    trace.y.forEach((point: any, index: any) => {
                        // if the trace hoverdata at the point matches the subplotIndex value
                        if (hoverData[index][key] == value) {
                            let exists = false;
                            // Check if the splitScatterTrace already exists
                            splitScatterTraces.forEach(splitTrace => {
                                if (splitTrace.name == trace.name + " SP " + String(subplotIndex)) {
                                    // if it exists, just append the point data
                                    splitTrace.x.push(trace.x[index]);
                                    splitTrace.y.push(trace.y[index]);
                                    splitTrace.text.push(trace.text[index]);
                                    splitTrace.hovertext.push(trace.hovertext[index]);
                                    splitTrace.marker.color.push(trace.marker.color[index]);
                                    exists = true;
                                } 
                            }); 
        
                            if (!exists) {
                                // otherwise, create a new trace
                                const newTrace = {
                                    ...trace, // Copy existing trace properties
                                    y: [trace.y[index]],
                                    x: [trace.x[index]],
                                    xaxis: `x${subplotIndex + 1}`,
                                    yaxis: `y${subplotIndex + 1}`,
                                    text: [trace.text[index]],
                                    hovertext: [trace.hovertext[index]],
                                    marker: {
                                        ...trace.marker,
                                        color: [trace.marker.color[index]]
                                    },
                                    name: trace.name + " SP " + String(subplotIndex),
                                }
                                // and append
                                splitScatterTraces.push(newTrace);
                                // increment index
                                tileScatterTraceIndex += 1;
                            }
                        }
                    })
                });
                numberOfItemsInPreviousKeys = Array.from(uniqueTileByValues[key]).length;
                keyIndex += 1;
            });
        }
    });

    // If tiling is enabled:
    if (layout.grid && layout.grid.columns && layout.grid.rows) {

        let boxtraceIndex = 0;
        const uniqueBoxTraceNames = new Map<string, number>(); // Map to track trace names and their assigned color indices.
        
        newTraces.forEach((trace: any) => {
            if (trace.type === "box" || trace.type === "bar") {
                if (!uniqueBoxTraceNames.has(trace.name)) {
                    // Assign a new color index to the trace if it hasn't been seen before.
                    uniqueBoxTraceNames.set(trace.name, boxtraceIndex);
                    boxtraceIndex += 1;
                }
        
                // Retrieve the assigned color index and apply it to the trace.
                const colorIndex = uniqueBoxTraceNames.get(trace.name) || 0;
                if (!(trace.name in colorOverrideMap) && (!plotConfig.fixedColorMode) && plotConfig.colorMap && plotConfig.colorMap[colorIndex]) {
                    trace.marker = { color: plotConfig.colorMap[colorIndex] };
                } 
                // trace.marker = { color: plotConfig.colorMap && ? plotConfig.colorMap[colorIndex] : colorOverrideMap[trace.name] || undefined};
        
                finalTraces.push(trace);
            }
        });
        
        // Adjust show legend to only show the first trace
        const uniqueScatterTraceNames = new Set();
        splitScatterTraces.forEach(trace => {
            const prefix = trace.name.split(' SP ')[0];
            if (uniqueScatterTraceNames.has(prefix)) {
                trace.showlegend = false;
            } else {
                uniqueScatterTraceNames.add(prefix);
                trace.name = prefix;
                trace.showlegend = true;
            }
            finalTraces.push(trace);
        });
    } else {
        finalTraces = newTraces;
    }
    // console.log("traces: ", traces);

    // If scatterColorBy is set to "same as traces", re-enable Plotly standard box points
    if (!plotConfig.scatterColorBy || (plotConfig.scatterColorBy === '')) {
        finalTraces.forEach((trace: any) => {
            if (trace.type === 'box') {
                trace.boxpoints = 'all';
            }
        });
    }

    return [newLayout, finalTraces];
};

export const colorDataVsDataTrace = (trace: any, plotConfig: PlotConfig, scatterMode?: string) => {

    // KH 9/25/24: Update the traces for a data vs. data plot to support unique formatting for each trace

    // return if the trace has no hovertext or if no color by parameter is specified:
    if (!trace.hovertext || !plotConfig.scatterColorBy || plotConfig.scatterColorBy === '') {
        return [trace];
    }

    if (scatterMode === undefined){
        scatterMode = 'markers'
    }

    let splitTraces: any = [];

    // Function to extract key-value pairs from hovertext, ignoring 'Value' and 'Treatment'
    const extractKeyValues = (text: string): { [key: string]: string } => {
        const keyValuePairs = text.split('<br />');
        const result: { [key: string]: string } = {};
        keyValuePairs.forEach(pair => {
            const [key, ...rest] = pair.split(':').map(part => part.trim());
            const value = rest.join(':').trim();
            if (key && value && key !== 'Value') {
                result[key] = value; // Store key-value pairs, ignoring specified keys
            }
        });
        return result;
    };

    // Collect unique key-value pairs from all hovertext entries
    // Define the type for the extracted key-value pairs
    type KeyValuePairs = { [key: string]: string };
    // Collect all extracted key-value pairs
    const extractedHoverData: KeyValuePairs[] = []; // Use an array of objects
    
    trace.hovertext.forEach((text: string) => {
        const extractedKeyValues = extractKeyValues(text);
        extractedHoverData.push(extractedKeyValues);
    });

    // Find unique hoverdata keys
    const uniqueHoverDataKeys = new Set<string>();
    extractedHoverData.forEach((hoverData) => {
        Object.keys(hoverData).forEach((key) => uniqueHoverDataKeys.add(key));
    });

    const colorByHoverTextKey = plotConfig.scatterColorBy;
    
    const text_labels = extractedHoverData.map(item => item[colorByHoverTextKey])
    const uniqueColorKeys = Array.from(new Set(text_labels));

    let traceIndex = 0;

    // Split out a new trace for each uniqueColorKey
    for (const uniqueKey of uniqueColorKeys) {

        // Figure out list of indices to use to split out the trace
        const traceIndices: any = [];
        const newHoverText: string[] = [];
        const newText: String[] = [];

        // Collect indices and hovertext for the current key
        extractedHoverData.forEach((item, index) => {
            if (item[colorByHoverTextKey] === uniqueKey) {
                traceIndices.push(index);
                const hover = Object.entries(item)
                    .map(([k, v]) => `${k}: ${v}`)
                    .join('<br />');
                newHoverText.push(hover);

                const label = plotConfig.scatterLabelBy ? item[plotConfig.scatterLabelBy] : uniqueKey;
                newText.push(label);
            }
        });

        const newColor = plotConfig.colorMap ? plotConfig.colorMap[traceIndex] : 'black';
        const newSymbol = plotConfig.symbolMap ? plotConfig.symbolMap[traceIndex] : 'circle';
        
        // Create the split trace with x and y values based on traceIndices
        const splitTrace = {
            ...trace, 
            name: uniqueKey,
            x: traceIndices.map((index: number) => trace.x[index]),
            y: traceIndices.map((index: number) => trace.y[index]),
            marker: {
                ...trace.marker,
                color: newColor,
                line: {
                    ...trace.marker.line,
                    color: newColor
                },
                symbol: newSymbol,
            },
            // text: plotConfig.scatterShowLabels ? new Array(traceIndices.length).fill(uniqueKey) : undefined,
            text: newText,
            hovertext: traceIndices.map((index: number) => trace.hovertext[index]),
            mode: plotConfig.scatterShowLabels ? scatterMode + '+text' : scatterMode,
            textposition: plotConfig.scatterShowLabels ? 'top center' : undefined
        };
        traceIndex += 1;
        splitTraces.push(splitTrace);

    }
    return splitTraces;
}

export const generateTracePvalues = async (dataDict: any, categoryDict: any, plotConfig: PlotConfig, axisCategory?: string): Promise<PValueDict> => {
    let pvalueDict: any = undefined
    for (let plotKey in dataDict) {
        
        for (let plotValue in dataDict[plotKey]) {
            let catDict: Record<string, number[]> = {}
            if (pvalueDict === undefined) {
                pvalueDict = {}
            }
            if (!(plotKey in pvalueDict)) {
                pvalueDict[plotKey] = {}
            }
            if (!(plotValue in pvalueDict[plotKey])) {
                pvalueDict[plotKey][plotValue] = []
            }
            if (axisCategory !== undefined && plotConfig.barMode === 'group' && plotConfig.plotType === 'bar' && plotConfig.barGroupBy && plotConfig.barGroupBy !== '') {
                let newCategory = categoryDict[axisCategory];
                let points = dataDict[plotKey][plotValue][newCategory];
                if (points === undefined || points.length === 0) {
                    // console.log("No points found for category: ", newCategory);
                    continue;
                }
                points.forEach((point: any) => {
                    if (plotConfig.barGroupBy !== undefined) {
                        let groupKey = point[plotConfig.barGroupBy.replace('Sample', 'Sample Title').replace('Treatment', 'Treatment_and_Dose').replace('Channel', 'channel_id').replace('Timepoint', 'Timepoint')];
                        if (!catDict[groupKey]) {
                            catDict[groupKey] = [];
                        }
                        catDict[groupKey].push(point.value);
                    }
                });
                // plotConfig.pvalueControl = Object.keys(catDict)[0]
                // catDict[newCategory] = values

            }
            else {
                for (let category in dataDict[plotKey][plotValue]) {
                    let newCategory = categoryDict[category]
                    let values = dataDict[plotKey][plotValue][category].map((item: any) => item.value)
                    catDict[newCategory] = values
                }
            }
            
            // console.log("Cat dict (meow)", catDict)
            let data: any = {
                'data':catDict,
                'operation':{
                    'name':plotConfig.pvalueMethod,
                    'mode':plotConfig.pvalue,
                    'control':(Object.keys(catDict).includes(plotConfig.pvalueControl ?? ''))  ? plotConfig.pvalueControl : Object.keys(catDict)[0]
                }
            }
            try {
                const response: PValueDict = await axios.post(`/tumors/api/v1/stats`, data, {headers: {"X-CSRFToken": getCookie("csrftoken")}})
                pvalueDict[plotKey][plotValue] = pvalueDict[plotKey][plotValue].concat(response.data)
            } catch (err: any) {
                if (err.response) {
                    console.log("err.response", err.response)
                    if (err.response.status === 403) {
                        window.location.href = '/accounts/login/?next=' + encodeURIComponent(window.location.pathname + window.location.search);
                    } else {
                        console.log(err);
                    }
                } 
                else {
                    console.log(err)
                }
            }
            

        }
    }
    return pvalueDict 
}

export const getPvalueHoverString = (pvalue: any, plotConfig: PlotConfig) => {
    let pval_string = ''
    if (plotConfig.pvalue === 'control'){
        let pval: any = pvalue;
        if (typeof pvalue === 'number'){
            let decimal = Math.log10(pvalue)
            if (decimal > -2){
                pval = pvalue.toFixed(2)
            }
            else {
                pval = pvalue.toExponential(2)
            }
        } 
        if (pvalue === 'Control') {
            pval_string = `<br />Negative Control`
        }  
        else { 
            pval_string = `<br />p-value: ${pval}`
        }   
    }
    return pval_string
}

export const getPvalueFromDict = (plotKey:any, plotValue:any, category:any, pValDict:PValueDict, plotConfig:PlotConfig) => {
    let pvalue: number | string | undefined = undefined
    if (plotConfig.pvalue && plotConfig.pvalue === 'control' && pValDict && plotKey in pValDict && plotValue in pValDict[plotKey]){
        if (category === plotConfig.pvalueControl){
            pvalue = "Control"
        }
        else {
            pvalue = pValDict[plotKey][plotValue].filter((item: any) => item.exp === category).map((item:any) => item.result.pval)[0] 
        }
    }
    return pvalue
}

export const getPvalueAnnotationString = (pvalue: number | string | undefined) => {
    if (typeof pvalue === 'number'){
        if (pvalue <= 0.0001){
            return '<b>****<b>'
        }
        else if (pvalue <= 0.001){
            return '<b>***<b>'
        }
        else if (pvalue <= 0.01){
            return '<b>**<b>'
        }
        else if (pvalue <= 0.05){
            return '<b>*<b>'
        }
        else {
            return '<b>ns<b>'
        }
    }
    return ''
}

export const addFilterInfoToPlotData = (versionTypeKey: any, axisFiltersState: FilterState, plotData: any) => {
    let additionalInfo: any = {}
    if (axisFiltersState) {
        for (let key in axisFiltersState) {
            const category = axisFiltersState[key].versionType
            const subcategory = axisFiltersState[key].column
            if (versionTypeKey === category && subcategory in plotData) {
                additionalInfo[subcategory] = plotData[subcategory]
            }
        }
    }
    return additionalInfo
}

export const generateDataDict = (aggregatedData: any, categorical: any, 
                          xValues: any, yValues: any, zValues: any, axisFiltersState: FilterState, 
                          shorten: boolean, sampleGroupOrder: any, groupedModeColumn: string): {dataDict: DataDict, categoryDict: {[category: string]: string}} => {

    // console.log("xValues: ", xValues);
    // console.log("yValues: ", yValues);
    // console.log("zValues: ", zValues);
    // console.log("categorical: ", categorical);


    // let toUse = Object.keys(xValues).length > 0 ? xValues : yValues  
    // let categoryAxis = Object.keys(xValues).length > 0 ? 'y' : 'x'

    // Check if it's a heatmap by presence of categorical data on x and y axis
    const isHeatmap = categorical !== undefined && Object.keys(categorical)?.includes('x') && Object.keys(categorical)?.includes('y');

    // Determine the categorical axis based on the selected variable
    let tempCategoryAxis;
    let tempDataAxis; 
    
    
    if (isHeatmap){
        const zValsPresent = (zValues && Object.keys(zValues).length > 0);
        const xDepth = checkDictionaryDepthRecursive(categorical['x'])
        const yDepth = checkDictionaryDepthRecursive(categorical['y'])

        if (zValsPresent){
            if (xDepth === yDepth){
                tempCategoryAxis = 'x'
            }
            else {
                tempCategoryAxis = (xDepth < yDepth) ? 'x' : 'y'
            }
            tempDataAxis = 'z'
        }
    }
    else {
        const xValsPresent = (xValues && Object.keys(xValues).length > 0);
        const yValsPresent = (yValues && Object.keys(yValues).length > 0);
        tempDataAxis = (xValsPresent) ? 'x' : (yValsPresent) ? 'y': undefined
        tempCategoryAxis = (xValsPresent) ? 'y' : (yValsPresent) ? 'x': undefined
    }

    if (tempCategoryAxis === undefined || tempDataAxis === undefined){
        return {dataDict: {}, categoryDict:{}}
    }
    const categoryAxis : string = tempCategoryAxis;
    const dataAxis : string = tempDataAxis;    

    // Determine which variable to use
    // Check length and choose the first variable with length > 0
    const toUse : any = {'x':xValues, 'y':yValues, 'z':zValues}[dataAxis]

    // console.log("toUse: ", toUse);
    // console.log("categoryAxis: ", categoryAxis);

    let categoryList: string[] = []
    let categoryListCols: string[] = []
    let categoryListAlt: string[] = []
    let categoryListColsAlt =  new Set<string>()

    let catDepth = checkDictionaryDepthRecursive(categorical);
    let dataDict: {[itemColumnGroup: string]: {[itemColumn: string]: {[category: string]: any[]}}} = {};

    

    // console.log("Categorical ", categorical)
    
    if (catDepth == 2 || isHeatmap) { // standard plotting
        // console.log("catDepth 2 - aggregatedData: ", aggregatedData);
        // console.log("standard plotting");
        for (let plotItem of aggregatedData) {
            // console.log(plotItem)
            let itemCategory = ''
            // for (let categoricalKey in categorical[categoryAxis]) {
                // if (!(categoricalKey in categorical) || checkDictionaryDepthRecursive(categorical[categoricalKey]) === 2){
                //     continue;
                // }
                itemCategory = Object.keys(categorical[categoryAxis]).map((col: any) => {
                    if (!categoryListCols.includes(col)){
                        categoryListCols.push(col); 
                    }
                    return plotItem[col];
                }).join(' - ')
                //    categoryList.push(itemCategory)
            // }
            for (let plottedKey of Object.keys(toUse)) {
                if (!(plottedKey in plotItem)) {
                    continue
                }
                if (!(plottedKey in dataDict)) {
                    dataDict[plottedKey] = {}
                }

                for (let plottedValue of toUse[plottedKey]['values']) {

                    if (!(plottedValue in dataDict[plottedKey])) {
                        dataDict[plottedKey][plottedValue] = {}
                    }
                    // if (!(itemCategory in dataDict[plottedKey][plottedValue])) {
                    //     dataDict[plottedKey][plottedValue][itemCategory] = []
                    // }
                    if (plotItem[plottedKey]) {
                        for (let plotDataKey of plotItem[plottedKey]) {
                            let additionalInfo = addFilterInfoToPlotData(plottedKey, axisFiltersState, plotDataKey)

                            let subItemCategory = ''
                            // console.time("subItemCategory" + i)
                            // if (isHeatmap){
                            //     let toPush = []
                            //     const altAxis : string = (categoryAxis === 'x') ? 'y' : 'x'
                            //     if (altAxis in categorical && checkDictionaryDepthRecursive(categorical[altAxis]) === 2) {
                            //         // for (let subKey in categorical[altAxis][plottedKey]){
                            //             // additionalInfo[subKey] = plotDataKey[subKey]
                            //             // toPush.push(plotDataKey[subKey])
                            //             // if (!categoryListColsAlt.has(subKey)){
                            //             // categoryListColsAlt.add(subKey)
                            //             // }
                            //         // }
                            //         // subItemCategory = [subItemCategory, ...toPush].join(' - ')
                            //     }
                            // }
                            // console.timeEnd("subItemCategory" + i)
                            if ('Sample Group' in plotItem) {
                                additionalInfo['Sample Group'] = plotItem['Sample Group']
                            }
                            for (let key of Object.keys(plotDataKey)){

                                const cat = key;
                                const val = plotDataKey[key];

                                if (cat !== plottedValue && typeof val === "string"){
                                    additionalInfo[cat] = val
                                }
                            }

                            if ( dataDict[plottedKey][plottedValue][itemCategory] === undefined){
                                categoryList.push(itemCategory)
                                dataDict[plottedKey][plottedValue][itemCategory] = []
                            }

                            dataDict[plottedKey][plottedValue][itemCategory].push({...{'value': plotDataKey[plottedValue], 'Treatment_and_Dose': plotItem['Treatment_and_Dose'], 
                                                                                    'Timepoint': plotItem['Timepoint'], 'Sample Title': plotItem['Sample Title'], 'channel_id': plotItem['channel_id']}, ...additionalInfo})

                        }
                    }
                }
            }
        }
        if (axisFiltersState && Object.keys(axisFiltersState).length > 0) {

            // For each custom filter
            getFilterKeys(axisFiltersState).forEach((key: number) => {
                const filter = axisFiltersState[key];
                const axisFilterVersionType = filter.versionType;
                const filterColumn = filter.column;

                // Check if the custom filter is matching categorical data on x or y aixs
                if (filter.type === 'categorical') {
                    if ((categorical['x'] && axisFilterVersionType in categorical['x'] && filterColumn in categorical['x'][axisFilterVersionType]) || 
                        (categorical['y'] && axisFilterVersionType in categorical['y'] && filterColumn in categorical['y'][axisFilterVersionType]) ||
                        (categorical['z'] && axisFilterVersionType in categorical['z'] && filterColumn in categorical['z'][axisFilterVersionType])) {

                        // Redefine the categoryList order to match the custom filter
                        let tempCategoryList: Record<string, number> = {};

                        filter.value.forEach((item: SearchableDropdownOption, index: number) => {
                            tempCategoryList[item.value] = index;
                        });

                        // Truman - removed since we can reverse it in the heatmap creation itself, this will help with consistency with sort order with other plots
                        // Reverse order for heatmap so that the first item is at the top of the heatmap
                        // if (isHeatmap) {
                        //     tempCategoryList = tempCategoryList.reverse();
                        // }
                        
                        // Do the same sorting for the dataDict
                        if (dataDict && dataDict[axisFilterVersionType]) {
                            const dataCol = Object.keys(dataDict[axisFilterVersionType])[0];  
                            
                            if (dataDict[axisFilterVersionType][dataCol]) {
                                if (categoryListCols.includes(filterColumn)){
                                    const filterColumnIndex = categoryListCols.indexOf(filterColumn)
                                    const entries = Object.entries(dataDict[axisFilterVersionType][dataCol])
                                    entries.sort((a, b) => tempCategoryList[a[0].split(' - ')[filterColumnIndex]] - tempCategoryList[b[0].split(' - ')[filterColumnIndex]])
                                    const sortedDict = Object.fromEntries(entries)
                                    dataDict[axisFilterVersionType][dataCol] = sortedDict
                                }
                                else {
                                    Object.keys(dataDict[axisFilterVersionType][dataCol]).forEach((axisName) => {
                                        if (dataDict[axisFilterVersionType][dataCol][axisName][0] !== undefined && dataDict[axisFilterVersionType][dataCol][axisName][0].hasOwnProperty(filterColumn)){
                                            dataDict[axisFilterVersionType][dataCol][axisName].sort((a, b) => tempCategoryList[a[filterColumn]] - tempCategoryList[b[filterColumn]]);
                                        }
                                    });
                                }
                            }
                            
                        } 
                    }
                }});
        }

        if (categoryListCols.includes('Sample Group') && sampleGroupOrder){
            let tempCategoryList = sampleGroupOrder.map((item: any) => item.value)
            Object.keys(dataDict).forEach((versionType) => {
                Object.keys(dataDict[versionType]).forEach((dataCol) => {
                    if (dataDict && dataDict[versionType]) { 
                        
                        if (dataDict[versionType][dataCol]) { // Sort by the sample group order
                            const groupColumnIndex = categoryListCols.indexOf('Sample Group')
                            const entries = Object.entries(dataDict[versionType][dataCol])

                            entries.sort((a, b) => tempCategoryList.indexOf(a[0].split(' - ')[groupColumnIndex]) - tempCategoryList.indexOf(b[0].split(' - ')[groupColumnIndex]))
                            const sortedDict = Object.fromEntries(entries)
                            dataDict[versionType][dataCol] = sortedDict
                        }
                        
                    } 
                })
            })
        }
        //    console.log("dataDict first step: ", dataDict);
    }
   // categorical data on an axis
   else if (catDepth == 3) {
        // console.log("categorical data on an axis");
        let categorySet = new Set<string>()
        
        // console.log("catDepth 3 - aggregatedData: ", aggregatedData);

        for (let plotItem of aggregatedData) {
            for (let plottedKey of Object.keys(toUse)) {
                let toUsePlotted = toUse[plottedKey].values
                if (!(plottedKey in plotItem)) {
                    continue
                }
                if (!(plottedKey in dataDict)) {
                    dataDict[plottedKey] = {}
                }
                if (!(toUsePlotted instanceof Array)) {
                    continue;
                }

                for (let plottedValue of toUsePlotted) {
                    if (!(plottedValue in dataDict[plottedKey])) {
                        dataDict[plottedKey][plottedValue] = {}
                    }
                    if (!(categoryAxis in categorical)){
                        continue
                    }
                    if (plottedKey in categorical[categoryAxis]) {
                        for (let categoryKey in categorical[categoryAxis][plottedKey]) {
                            for (let categoryValue of categorical[categoryAxis][plottedKey][categoryKey]) {
                                for (let fullPlotItem of plotItem[plottedKey]) {
                                    let categoryName = fullPlotItem[categoryKey]
                                    if (categoryValue === categoryName) {
                                        if (categorical[categoryAxis][plottedKey][categoryKey].includes(categoryName)) {                     
                                            categorySet.add(categoryName)
                                            let value = fullPlotItem[plottedValue]
                                            if (!(categoryName in dataDict[plottedKey][plottedValue])) {
                                                dataDict[plottedKey][plottedValue][categoryName] = []
                                            }
                                            let additionalInfo = addFilterInfoToPlotData(plottedKey, axisFiltersState, fullPlotItem)
                                            if ('Sample Group' in plotItem) {
                                                additionalInfo['Sample Group'] = plotItem['Sample Group']
                                            }
                                            additionalInfo[categoryKey]  = categoryValue;
                                            dataDict[plottedKey][plottedValue][categoryName].push({...{'value': value, 'Treatment_and_Dose': plotItem['Treatment_and_Dose'], 
                                                                                    'Timepoint': plotItem['Timepoint'], 'Sample Title': plotItem['Sample Title'], 'channel_id': plotItem['channel_id']}, ...additionalInfo})
                                        }
                                        continue 
                                    }
                                }
                            }
                        }
                    }
                }

           }

        }
        categoryList = Array.from(categorySet)
   
        if (axisFiltersState && Object.keys(axisFiltersState).length > 0) {

            // console.log("axisFiltersState: ", axisFiltersState);
            // console.log("categorical: ", categorical);
            // console.log("dataDict: ", dataDict);

            // For each custom filter
            Object.keys(axisFiltersState).forEach((key: any) => {

                const axisFilterVersionType = axisFiltersState[key]?.versionType;
                const filterColumn = axisFiltersState[key]?.column;

                // Check if the custom filter is matching categorical data on x or y aixs
                if ((categorical['x'] && axisFilterVersionType in categorical['x'] && filterColumn in categorical['x'][axisFilterVersionType]) || 
                    (categorical['y'] && axisFilterVersionType in categorical['y'] && filterColumn in categorical['y'][axisFilterVersionType]) ||
                    (categorical['z'] && axisFilterVersionType in categorical['z'] && filterColumn in categorical['z'][axisFilterVersionType])) {

                    // Redefine the categoryList order to match the custom filter
                    categoryList = axisFiltersState[key].value.map((item: any) => item.value);
                                
                    // Do the same sorting for the dataDict
                    if (dataDict && dataDict[axisFilterVersionType]) {
                        const dataCol = Object.keys(dataDict[axisFilterVersionType])[0];  
                        let sortedData: Record<string, any> = {}; 
            
                        categoryList.forEach((category) => {
                            if (dataDict[axisFilterVersionType][dataCol] && dataDict[axisFilterVersionType][dataCol].hasOwnProperty(category)) {
                                sortedData[category] = dataDict[axisFilterVersionType][dataCol][category];
                            }
                        });
                        dataDict[axisFilterVersionType][dataCol] = sortedData;
                    } 
                }
            });
 
        }

   }

   let categoryDict: {[category: string]: string} = {}
//    console.log("category list", categoryList)
   if (shorten && categoryList.length > 0) {
       let shortenedCategories = removeCommonParts(categoryList)
       for (let i in shortenedCategories) {
           categoryDict[categoryList[i]] = shortenedCategories[i]
       }
   }

//    console.log("dataDict: ", dataDict);
//    console.log("categoryDict: ", categoryDict);
   return {dataDict, categoryDict}
}

export const generateCategoricalPlotDataDict = (xValues: any, yValues: any, zValues: any, categorical: any, plotData: any, 
                                        shorten: boolean, axisFiltersState: FilterState, tileDict?: any, tileOrder?: any, sampleGroupOrder?: any, groupedModeColumn?: string) => {

    if (tileDict && Object.keys(tileDict).length > 0) {      
        let order = (tileOrder && tileOrder.length > 0) ? tileOrder : Object.keys(tileDict)
        let dataList = []
        for (let key of order) {
            // console.log("tileDict[key]: ", tileDict[key]);
            let {dataDict, categoryDict} = generateDataDict(tileDict[key], categorical, xValues, yValues, zValues, axisFiltersState, shorten ? true : false, sampleGroupOrder, groupedModeColumn ?? '')
            dataList.push({dataDict, categoryDict})
        }
        return dataList
    } else {
        // console.log("plotData: ", plotData);
        let {dataDict, categoryDict} = generateDataDict(plotData, categorical, xValues, yValues, zValues, axisFiltersState, shorten ? true : false, sampleGroupOrder, groupedModeColumn ?? '')
        return [{dataDict, categoryDict}];
    }
}

export const takeMeanofArray = (array: any[]) => {
    let numericValues = array 
        .filter(value => value !== "N/A" && !isNaN(Number(value)))
        .map(value => Number(value));

    let sum = numericValues.reduce((acc, value) => acc + value, 0);
    let mean = numericValues.length > 0 ? sum / numericValues.length : null;
    return mean

}

export const handleArrayGroup = (group: any, values:{ [key: string]: { filterItems: any[]; aggregationMethod: any; groupBy: any[], values: any[] } }, takeMean: boolean) => {
    if (!group) {
        return []
    }
    
    let xValuesToMeanGroup: number [] = []

    for (let xVersionType in values) {
        let xValuesToMean: number [] = []
        let valuesList: any = values[xVersionType]['values']
 
        for (let xValue of valuesList) {

            if (!group[xVersionType]) {
                continue
            }

            for (let groupValue of group[xVersionType]) {
                xValuesToMean.push(groupValue[xValue])
            }
        }

        if (takeMean) {
            let groupMean = takeMeanofArray(xValuesToMean)
            if (groupMean !== null)
                xValuesToMeanGroup.push(groupMean)
        } else {
            xValuesToMeanGroup.push(...xValuesToMean)
        }
    } 

    if (takeMean) {
        return [[takeMeanofArray(xValuesToMeanGroup) as number]]
    } else {
        return [xValuesToMeanGroup]
    }
}

export const checkDictionaryDepthRecursive = (dict: any) => {
    let depth = 0;
    for (let key in dict) {
        if (typeof dict[key] == 'object') {
            let depthOfKey = checkDictionaryDepthRecursive(dict[key]) + 1;
            depth = Math.max(depth, depthOfKey);
        }
    }
    return depth;
}

export const filterAxis = (axisFilterState: FilterState, plotData: DataRow[], level:'raw' | 'absolute' | 'relative' | 'cat', skipGeneFilter?: boolean, heatmapKeepIfAnyMatch?: boolean, axisValues?: any) => {
    const newPlotData: DataRow[] = [];
    const originalPlotData = structuredClone(plotData); // Deep copy to prevent mutation
    
    const dataMask: {[vt: string]: boolean[]}[] = [];

    // This is the value we will use for the keep if any logic (if defined)
    let keepIfAnyCategory = axisValues && heatmapKeepIfAnyMatch ? Object.keys(axisValues)[0] : undefined;
    let keepIfAnySubCat = axisValues && heatmapKeepIfAnyMatch ? Object.keys(axisValues[keepIfAnyCategory ?? 0])[0] : undefined;

    // List of categories (beloging to the keep if any data[first][i][second] category) that we should override to always keep
    const heatmapCategoryOverrides: string[] = []
   
    for (let data of originalPlotData) {
        // let includeData = true; // Assume data is included unless a condition fails
        let submask: {[vt: string]: boolean[]} = {}; // mask of the data series within the data point for each version type 
        
        for (let filterKey in axisFilterState) {
            const filter = axisFilterState[filterKey];
            let category = filter.versionType
            let subcategory = filter.column
           
            const include = filter.filterBehavior === 'include';
            const categorical = filter.type === 'categorical';

            let filterSubmask: boolean[] = [];
            
            if (categorical){ // categorical case
                // Hash the values list to make for quicker checks
                let valuesList: Set<string> = new Set(filter.value.map((item: SearchableDropdownOption) => item.value));
                if (skipGeneFilter && subcategory == 'Gene') {
                    continue;
                }

                if (category in data) {
                    let dataCata = data[category];
                    if (Array.isArray(dataCata)) {
                        // Create a mask for the individual data points within each category (version type). 
                        // Sometimes we will have subcategories of length 1 (usually after group by), but we must account for all lengths 
                        filterSubmask = (dataCata).map((plottedData: SubDataRow) => {
                            let includeDatum = true;

                            if (subcategory in plottedData) {
                                if (include) {
                                    return valuesList.has(plottedData[subcategory] as string)
                                }
                                else {
                                    return !valuesList.has(plottedData[subcategory] as string)
                                }
                            }

                            if (includeDatum && heatmapKeepIfAnyMatch) {
                                // if Subcat is undefined, we are in the subcat case
                                if (keepIfAnySubCat && keepIfAnySubCat in plottedData && category === keepIfAnyCategory) {
                                    // If the point is being included and we are in heatmapKeepIfAnyMatch mode AND the category (versiontype) matches, and the subcat is in the data, 
                                    // THEN we can include this subcat in the list of overrides
                                    
                                    const value = plottedData[keepIfAnySubCat] as string; // should always be categorical 
                                    if (!heatmapCategoryOverrides.includes(value)) {
                                        heatmapCategoryOverrides.push(value);
                                    }
                                }
                                else if (keepIfAnyCategory && keepIfAnyCategory in data ) { // Otherwise, we are in the top level index case (treatment/timepoint/sample etc)
                                    const keepDataCata = data[keepIfAnyCategory]
                                    if (typeof keepDataCata === 'string'){
                                        if (!heatmapCategoryOverrides.includes(keepDataCata)) {
                                            heatmapCategoryOverrides.push(keepDataCata);
                                        }
                                    }
                                }
                            }

                            return includeDatum; 
                        });
                    } 
                }
            }
            else if (filter.level == level && !categorical){ // numerical case
                let filterValues = filter.value;
                let include = filter.filterBehavior === 'include';
                let min = filterValues[0];
                let max = filterValues[1];

                if (category in data) {
                    let dataCata = data[category];
                    if (Array.isArray(dataCata)) {
                        filterSubmask = (dataCata).map((plottedData: SubDataRow) => {
                            let includeDatum = true; 
                            if (subcategory in plottedData) {
                                if (include) {
                                    // Inclusive numeric filter logic: 
                                    // IFF filter is null or the number is between the min and max, then we include
                                    includeDatum = (min === null || (plottedData[subcategory] as number) >= min) && (max === null || (plottedData[subcategory] as number) <= max);
                                }
                                else {
                                    // Exclusive numeric filter logic: 
                                    // IFF filter is null or value is outside the specified range.
                                    // This mode can be confusing if the filters are null since if one side is null, it will include everything, regardless of the other filter
                                    // [TODO] Maybe we should make this clear in the UI, since an exclusive filter with one side missing doesn't make sense
                                    includeDatum = (min === null || (plottedData[subcategory] as number) < min) || (max === null || (plottedData[subcategory] as number) > max);
                                }
                            }
                            
                            if (includeDatum && heatmapKeepIfAnyMatch) {
                                // if Subcat is undefined, we are in the subcat case
                                if (keepIfAnySubCat && keepIfAnySubCat in plottedData && category === keepIfAnyCategory) {
                                    // If the point is being included and we are in heatmapKeepIfAnyMatch mode AND the category (versiontype) matches, and the subcat is in the data, 
                                    // THEN we can include this subcat in the list of overrides
                                    
                                    const value = plottedData[keepIfAnySubCat] as string; // should always be categorical 
                                    if (!heatmapCategoryOverrides.includes(value)) {
                                        heatmapCategoryOverrides.push(value);
                                    }
                                }
                                else if (keepIfAnyCategory && keepIfAnyCategory in data ) { // Otherwise, we are in the top level index case (treatment/timepoint/sample etc)
                                    const keepDataCata = data[keepIfAnyCategory]
                                    if (typeof keepDataCata === 'string'){
                                        if (!heatmapCategoryOverrides.includes(keepDataCata)) {
                                            heatmapCategoryOverrides.push(keepDataCata);
                                        }
                                    }
                                }
                            }

                            return includeDatum
                        });
                    }
                }
            }
            else {
                // if we reach this, the filter is just a different level. 
                // IE if we are filtering raw data, we wouldn't apply a relative filter. Safe to skip then.
                continue;
            }

            if (category in submask) {
                // merge current filter submask with previous at this version type
                const prevSubmask = submask[category];
                const newSubmask = prevSubmask.map((value: boolean, index: number) => {
                    return value && filterSubmask[index]
                })
                submask[category] = newSubmask;
            }
            else { // otherwise, just set it since we haven't seen it before
                submask[category] = structuredClone(filterSubmask);
            }
        }

        // add the submasks row this row to the whole datamasks
        dataMask.push(structuredClone(submask));
    }

    let i = 0; // row index of plot data should be aligned with dataMask indicies
    for (let data of originalPlotData) {
        const rowCopy = structuredClone(data)
        const submask = dataMask[i];

        for (let vt of Object.keys(data)) {
            if (vt in submask) {
                rowCopy[vt] = rowCopy[vt].filter((subRow: SubDataRow, index: number) => {
                    if (heatmapKeepIfAnyMatch && heatmapCategoryOverrides.length) {
                        // If we determined earlier that a category should be overwritten, then always return true for rows/subrows matching that category
                        if (vt == keepIfAnyCategory && keepIfAnySubCat && keepIfAnySubCat in subRow) {
                            if (heatmapCategoryOverrides.includes(subRow[keepIfAnySubCat] as string)){
                                return true;
                            }
                        }
                        else if (keepIfAnyCategory && keepIfAnyCategory in rowCopy) {
                            const keepDataCata = rowCopy[keepIfAnyCategory];
                            if (typeof keepDataCata === 'string' && heatmapCategoryOverrides.includes(keepDataCata)) {
                                return true;
                            }
                        }
                        return false;
                    }
                    // Use the mask at this row and version type to determine if we should filter the data
                    return submask[vt][index]
                })
            }   
        }
        // once all the masking is complete, add the filtered data to the new plot data
        newPlotData.push(rowCopy);
        i+=1;
    }

    // Now check if the originalPlot Data has x-axis set to the version type and column matching the axisFilterState column
    // If so, sort the enteries in data based on the entry.x value matching axisFilterState.value.value sequence

    return newPlotData;
};

export const normPlotData = (plotData: any, normalizeBy: string, units?: string, values?: any, axisFiltersState?: FilterState, axisName?: string) => {
    let error = ''
    // this line splits out only the first '|' because the column name could contain a '|'
    let [first, second] = normalizeBy.split(/\|([\s\S]*)/) // for now, assume normalize by and values are in the same version type 
    plotData = JSON.parse(JSON.stringify(plotData))
    for (let data of plotData){
        for (let value of values[first].values){
            if (data[first] !== undefined){
                for (let datum of data[first]){
                    if (datum[second] === 0){
                        datum[second] = 1
                        error = "Divide by zero encountered during normalization. Some results may not appear."
                        continue
                    }
                    if (units === 'percentage'){
                        datum[value] = 100 * datum[value]/datum[second]
                    }
                    else if (units === 'log2_fold_change'){
                        if (datum[value]/datum[second] < 0) {
                            error = "Log of negative value encountered in normalization. Some results may not appear"
                            continue
                        }
                        datum[value] = Math.log2(datum[value]/datum[second])
                    }
                    else if (units === 'log2_fold_change_smooth'){
                        if (datum[value]/datum[second] < 0) {
                            error = "Log of negative value encountered in normalization. Some results may not appear"
                            continue
                        }
                        datum[value] = computeSmoothedLog2FC(datum[value],datum[second])
                    }
                    else {
                        datum[value] = datum[value]/datum[second]
                    }
                }
            }
            else {
                // return {plotData, error:"Selected Data not found."}
            }
        }
    }

    return {plotData, error}
}

export const normalizeData = (plotData: any, xValues: any, xProcessing: any, yValues: any, yProcessing: any, zValues: any, zProcessing: any, axisFiltersState: FilterState) => {
    let error = ''
    if (xProcessing && xProcessing.normalizeBy){
        let { plotData: normedXPlotData, error: normXError } = normPlotData(plotData, xProcessing.normalizeBy, xProcessing.normalizeUnits, xValues, axisFiltersState, 'X-Axis Data')
        if (normXError) {
            error = normXError
        }
        plotData = normedXPlotData
    }
    if (yProcessing && yProcessing.normalizeBy){
        let { plotData: normedYPlotData, error: normYError } = normPlotData(plotData, yProcessing.normalizeBy, yProcessing.normalizeUnits, yValues, axisFiltersState, 'Y-Axis Data')
        if (normYError) {
            error = normYError
        }
        plotData = normedYPlotData
    }
    if (zProcessing && zProcessing.normalizeBy){
        let { plotData: normedZPlotData, error: normZError } = normPlotData(plotData, zProcessing.normalizeBy, zProcessing.normalizeUnits, zValues, axisFiltersState, 'Z-Axis Data')
        if (normZError) {
            error = normZError
        }
        plotData = normedZPlotData
    }
    if (xProcessing && xProcessing.normReferences !== undefined && !!xProcessing.normReferences.length){
        let { plotData: relativeXPlotData, error: relativeXError } = calculateRelativePlotData(plotData, xProcessing.normReferences, xProcessing.normHideReference, xProcessing.normRelativeUnits, xValues, xProcessing.groupBy, axisFiltersState, 'X-Axis Data')
        if (relativeXError) {
            error = relativeXError
        }
        plotData = relativeXPlotData
    }
    else if (yProcessing  && yProcessing.normReferences !== undefined && !!yProcessing.normReferences.length){
        let { plotData: relativeYPlotData, error: relativeYError } = calculateRelativePlotData(plotData, yProcessing.normReferences, yProcessing.normHideReference, yProcessing.normRelativeUnits, yValues, yProcessing.groupBy, axisFiltersState, 'Y-Axis Data')
        if (relativeYError) {
            error = relativeYError
        }
        plotData = relativeYPlotData
    }
    else if (zProcessing && zProcessing.normReferences !== undefined && !!zProcessing.normReferences.length){
        let { plotData: relativeZPlotData, error: relativeZError } = calculateRelativePlotData(plotData, zProcessing.normReferences, zProcessing.normHideReference, zProcessing.normRelativeUnits, zValues, zProcessing.groupBy, axisFiltersState, 'Z-Axis Data')
        if (relativeZError) {
            error = relativeZError
        }
        plotData = relativeZPlotData
    }
    return { plotData, error }
}

export const sampleGroupStep = (plotData: any, sampleGroupDict: Record<string, string>) => {
    
    const originalPlotData = JSON.parse(JSON.stringify(plotData)); // Deep copy to prevent mutation
    
    for (let plotItem of originalPlotData) {
        let sample = plotItem['Sample Title']

        if (sample in sampleGroupDict) {
            plotItem['Sample Group'] = sampleGroupDict[sample]
        } else {
            plotItem['Sample Group'] = 'Other'
        }
    }
    return originalPlotData
}

export const aggregateData = (plotData: any, xValues: any, xAggregation: any, yValues: any, 
                              yAggregation: any, zValues: any, zAggregation: any, axisFiltersState: FilterState, sortOrder: string[]) => {

    let error = ''
    if (xAggregation && xAggregation.groupBy) {
        if (xAggregation.groupBy.length > 0) {
            let groupByCols = (xAggregation.processingMode === 'relative' && yAggregation.groupByRelative !== undefined) ? xAggregation.groupByRelative : xAggregation.groupBy 
            let {plotData: groupedXPlotData, error: groupXError} = groupPlotData(plotData, groupByCols, xValues, undefined, undefined, true, axisFiltersState, 'X-Axis Data', undefined, sortOrder)
            if (groupXError) {
                error = groupXError
            }
            plotData = groupedXPlotData
        }
    }
    else if (yAggregation && yAggregation.groupBy) {
        if (yAggregation.groupBy.length > 0) {
            let groupByCols = (yAggregation.processingMode === 'relative' && yAggregation.groupByRelative !== undefined) ? yAggregation.groupByRelative : yAggregation.groupBy 
            let {plotData: groupedYPlotData, error: groupYError} = groupPlotData(plotData, groupByCols, yValues, undefined, undefined, true, axisFiltersState, 'Y-Axis Data', undefined, sortOrder)
            if (groupYError) {
                error = groupYError
            }
            plotData = groupedYPlotData
        }
    }
    else if (zAggregation && zAggregation.groupBy) {
        if (zAggregation.groupBy.length > 0) {
            let groupByCols = (zAggregation.processingMode === 'relative' && zAggregation.groupByRelative !== undefined) ? zAggregation.groupByRelative : zAggregation.groupBy 
            let {plotData: groupedZPlotData, error: groupYError} = groupPlotData(plotData, groupByCols, zValues, undefined, undefined, true, axisFiltersState, 'Z-Axis Data', undefined, sortOrder)
            if (groupYError) {
                error = groupYError
            }
            plotData = groupedZPlotData
        }
    }
    return {plotData, error}
}

// const computeSmoothedLog2FC = (
//     numerator: number,
//     denominator: number,
//     k: number = 5,   // midpoint
//     n: number = 2,    // steepness
//     epsilon: number = 1e-9
// ): number => {

//     const fc = (numerator + epsilon) / (denominator + epsilon);
//     const log2FC = Math.log2(fc);

//     // Smooth factor using a Hill function
//     const smoothFactor = Math.pow(denominator, n) / (Math.pow(denominator, n) + Math.pow(k, n));

//     return log2FC * smoothFactor;
// };

// use a pseudocount to smooth the log2 fold change calculation
const computeSmoothedLog2FC = (
    numerator: number,
    denominator: number,
    pseudocount: number = 5
): number => {

    const adjustedNumerator = numerator + pseudocount;
    const adjustedDenominator = denominator + pseudocount;

    const fc = adjustedNumerator / adjustedDenominator;
    const log2FC = Math.log2(fc);

    return log2FC;
}

export const calculateRelativePlotData = (plotData: any, references: Reference[], hideReference: boolean, units?: string, values?: any, groupby?: any, axisFiltersState?: FilterState, axisName?: string, ) => {
    let error = ''
    //  // for now, assume normalize by and values are in the same version type
    let referenceData = []
    plotData = structuredClone(plotData)
    console.time("Building Reference Data")
    for (let data of plotData){
        let isMatch = true
        let dataCopy = structuredClone(data) // create copy of reference so we cant accidentally modify the original data
        for (let ref of references){
            let [first, second] = ref.column.value.split(/\|([\s\S]*)/)

            if (second === undefined) {
                // top level index case (simple)
                isMatch = isMatch && ref.value.value === data[first]
                if (dataCopy[first] === undefined){
                    return {plotData, error:'Selected Data not present in the plot.'}
                }
            }
            if (second !== undefined && isMatch){
                // non-top level index case. Only include reference values 
                if (dataCopy[first] !== undefined){
                    dataCopy[first] = dataCopy[first].filter((row:any) => row[second] === ref.value.value)
                    if (dataCopy[first].length === 0){
                        isMatch = false
                    }
                } 
                else {
                    return {plotData, error:'Selected data not present in the plot.'}
                }
            }
        }
        if (isMatch){
            data['isReference'] = true
            dataCopy['isReference'] = true
            referenceData.push(dataCopy)
        }
    }
    console.timeEnd("Building Reference Data")
    // console.log("plotdata", plotData)
    console.log("reference data", referenceData);

    // console.log("Values", values)
    if (referenceData.length === 0){
        const condition = references.map(ref => ref.column.value.replace('|', ' ') + ' = ' + ref.value.value).join(' and ')
        error = `No data matches the reference conditions: "${condition}". Please adjust the reference conditions, or the plot filters.`
        return {plotData, error}
    }
    // match the indicies of each iterated point to a SINGLE reference value. If it matches more than one, combine the reference values
    const topLevelRefs = references.map(ref => ref.column.value.split(/\|([\s\S]*)/)[0]) 
    let referencesSet = new Set(references.map(ref => ref.column.value))

    const groupbySplitMap: {[key: string]: string[]} = {}
    for (let index of groupby) {
        let [first, second] = index.split(/\|([\s\S]*)/)
        groupbySplitMap[index] = [first, second];
    }
    let unusedIndicies: any[] = []

    let referenceMatchMap: {[key: string]: any} = {} // map of reference indicies to reference data, essential for performance

    let matchingReference = undefined;
    for (let data of plotData){ 
        if (matchingReference !== undefined) {
            let isMatch = true;
            let matchKeyArr = []
            for (let index of groupby) {
                if (topLevelRefs.includes(index)){
                    continue
                }
                if (typeof data[index] === 'string' || data[index] instanceof String || typeof data[index] === 'number'){
                    isMatch = isMatch && data[index] === matchingReference[index];
                    matchKeyArr.push(data[index])
                    // if (!isMatch) break;
                }
            }
            if (!isMatch) {
                matchingReference = undefined;
                let matchKey = matchKeyArr.join('|')
                if (matchKey in referenceMatchMap){
                    matchingReference = referenceMatchMap[matchKey];
                    // console.log("Re-using matching reference with key", matchKey)
                }
                // else {
                //     console.log("No matching reference with key", matchKey)
                //     console.log("referenceMatchMap", referenceMatchMap)
                // }
            }
            else {
                // console.log("Re-using previous matching reference without key", matchKeyArr)
            }
        }
        if (matchingReference === undefined){ // only find a new matching reference if we dont already have one
            for (let e of referenceData){
                let element = structuredClone(e) // make a copy so we dont accidentally modify the original reference data
                let isMatch = true
                let usedIndexValues: string[] = []
                for (let index of groupby) {

                    if (topLevelRefs.includes(index)){
                        continue
                    }

                    if (typeof data[index] === 'string' || data[index] instanceof String || typeof data[index] === 'number'){
                        isMatch = isMatch && data[index] === element[index]
                        if (data[index] === element[index]){
                            usedIndexValues.push(''+data[index])
                        }
                    }
                    else if (!unusedIndicies.includes(index)){
                        // console.log("pushing index", index)
                        unusedIndicies.push(index)
                    }
                    
                }     
                if (isMatch && matchingReference === undefined){
                    matchingReference = JSON.parse(JSON.stringify(element))
                }
                else if (isMatch && matchingReference !== undefined){
                    // console.log("error multiple indicies")
                    // return {plotData, error:'Multiple indicies matching data. Try specifying less in the group by.'}
                    
                    for (let missingIndex of unusedIndicies) { 
                        // The bottom level indicies can get spread out between different references, this ensures that a single reference has all the bottom level indicies
                        let [v, c] = groupbySplitMap[missingIndex]
                        matchingReference[v] = matchingReference[v].concat(JSON.parse(JSON.stringify(element[v])))
                    }
                } 
                let referenceKey = usedIndexValues.join('|')
                if (isMatch && !(usedIndexValues.length === 0) && !(referenceKey in referenceMatchMap)){
                    referenceMatchMap[referenceKey] = matchingReference;
                }
            }
        }
        // console.log("Matching", matchingReference)
        // console.log("Unused indicies", unusedIndicies)
        if (matchingReference === undefined){
            // console.log("Erroring")
            error = 'Unable to find matching references. Try changing Group By values to aggregate the data further.'
            // return {plotData, error:'No matching data to reference. Please specify a different relative calculation'}
            continue
        }

        for (let vt in values){
            for (let value of values[vt].values){
                // console.log("value value value", value)
                for (let datumIndex in data[vt]){
                    if (unusedIndicies.length){
                        // console.log(vt, datumIndex, value)
                        // case where we have to match 
                        for (let index of unusedIndicies){
                            let [version, column] = index.split('|')
                            let referenceDatumIndex = datumIndex;
                            // const isReferenceColumn = references.some(item => {
                            //     let [refVersion, refColumn] = item.column.value.split('|')
                            //     return refVersion === version && refColumn === column
                            // })
                            const isReferenceColumn = referencesSet.has(index);

                            // let refColumnValue = matchingReference[vt][referenceDatumIndex][column]

                            for (let referenceIndex in matchingReference[vt]){
                                if (isReferenceColumn && datumIndex < matchingReference[vt].length) {
                                    referenceDatumIndex = datumIndex;
                                    break;
                                }
                                else if (matchingReference[vt][referenceIndex][column] === data[vt][datumIndex][column]){
                                    referenceDatumIndex = referenceIndex
                                    break;
                                }
                                else {
                                    referenceDatumIndex = '0'
                                }
                            }
                            // console.log("data vs reference data", data[vt][datumIndex], matchingReference[vt][referenceDatumIndex])
                            if (version === vt && (isReferenceColumn || data[vt][datumIndex][column] === matchingReference[vt][referenceDatumIndex][column])){
                                // console.log("Match!!")
                                if (units === 'percentage'){
                                    data[vt][datumIndex][value] = 100 * (data[vt][datumIndex][value]/matchingReference[vt][referenceDatumIndex][value]);
                                }
                                else if (units === 'percentage_delta'){
                                    data[vt][datumIndex][value] = 100 * ((data[vt][datumIndex][value] - matchingReference[vt][referenceDatumIndex][value] )/matchingReference[vt][referenceDatumIndex][value]);
                                }
                                else if (units === 'log2_fold_change'){
                                    data[vt][datumIndex][value] = Math.log2(data[vt][datumIndex][value]/matchingReference[vt][referenceDatumIndex][value]);
                                }
                                else if (units === 'log2_fold_change_smooth') {
                                    const numerator = data[vt][datumIndex][value];
                                    const denominator = matchingReference[vt][referenceDatumIndex][value];
                                    data[vt][datumIndex][value] = computeSmoothedLog2FC(numerator, denominator);
                                }
                                else if (units === 'delta'){
                                    data[vt][datumIndex][value] = data[vt][datumIndex][value] - matchingReference[vt][referenceDatumIndex][value];
                                }
                                else if (units === 'fold_change'){
                                    data[vt][datumIndex][value] = data[vt][datumIndex][value]/matchingReference[vt][referenceDatumIndex][value];
                                }
                                else {
                                    data[vt][datumIndex][value] = data[vt][datumIndex][value]/matchingReference[vt][referenceDatumIndex][value];
                                }

                            }
                            else {
                                // console.log("No match found for index", index, "with data", data[vt][datumIndex], "and reference", matchingReference[vt][referenceDatumIndex])
                                data[vt][datumIndex][value] = NaN
                            }
                        }

                    }
                    else {
                        // case with only top level indicies
                        // console.log(vt, datumIndex, value)
                        // console.log("matchingReference", matchingReference)
                        // console.log("data", data)
                        // console.log("Data line", data[vt])
                        // console.log("Matching Reference line", matchingReference[vt])
                        if (matchingReference[vt] === undefined){
                            error = "No matching reference data found for " + vt + ". Please specify a different relative calculation."
                            continue
                        }

                        if (matchingReference[vt] && !(datumIndex in matchingReference[vt])){
                            error = "Index mismatching"
                            continue
                            // return {plotData, error:'Index mismatching'}
                        }
                        
                        // console.log("units lower", units) 
                        if (units === 'percentage'){
                            data[vt][datumIndex][value] =  100 * (data[vt][datumIndex][value]/matchingReference[vt][datumIndex][value]);
                        }
                        else if (units === 'percentage_delta'){
                            data[vt][datumIndex][value] =  100 * ((data[vt][datumIndex][value] - matchingReference[vt][datumIndex][value] )/matchingReference[vt][datumIndex][value]);
                        }
                        else if (units === 'log2_fold_change'){
                            data[vt][datumIndex][value] = Math.log2(data[vt][datumIndex][value]/matchingReference[vt][datumIndex][value]);
                        }
                        else if (units === 'log2_fold_change_smooth') {
                            const numerator = data[vt][datumIndex][value];
                            const denominator = matchingReference[vt][datumIndex][value];
                            data[vt][datumIndex][value] = computeSmoothedLog2FC(numerator, denominator);
                        }
                        else if (units === 'delta'){
                            data[vt][datumIndex][value] = data[vt][datumIndex][value] - matchingReference[vt][datumIndex][value];
                        } 
                        else if (units === 'fold_change'){
                            data[vt][datumIndex][value] = data[vt][datumIndex][value]/matchingReference[vt][datumIndex][value];
                        } 
                        else {
                            data[vt][datumIndex][value] = data[vt][datumIndex][value]/matchingReference[vt][datumIndex][value];
                        }

                    }
                }
            }
        }
    }
    if (hideReference){
        let indiciesToRemove = []
        for (let dataIndex in plotData){
            let data = plotData[dataIndex]
            if (data.isReference){
                let deleteFullReference = true
                for (let vt in values){
                    for (let value of values[vt].values){
                        // console.log("value value value", value)
                        let noReferenceSubIndex = true
                        for (let datumIndex in data[vt]){
                            
                            if (unusedIndicies.length){ 
                                
                                
                                for (let index of unusedIndicies){
                                    let [version, column] = index.split('|')
                                    let referenceDatumIndex = datumIndex;
                                    const isReferenceColumn = references.some(item => {
                                        let [refVersion, refColumn] = item.column.value.split('|')
                                        return refVersion === version && refColumn === column && item.value.value === data[vt][datumIndex][column]
                                    })
                                    if (version == vt && isReferenceColumn){
                                        data[vt][datumIndex] = {} 
                                        // data[vt][datumIndex][column] = ''
                                        noReferenceSubIndex = false
                                        deleteFullReference = false
                                    }
                                }
                                
                            }
                            else {
                                data[vt][datumIndex][value] = undefined
                            }
                        }
                        // if (noReferenceSubIndex){
                            
                        //         console.log("noreference sub index", datumIndex)
                        //         data[vt][datumIndex][value] = undefined
                        // }
                    }
                } 
                if (deleteFullReference) {
                    indiciesToRemove.push(parseInt(dataIndex))
                }
            }
        }
        indiciesToRemove = indiciesToRemove.sort((a, b) => b-a)
        for (let index of indiciesToRemove){
            plotData.splice(index, 1)
        }
    }
    plotData = structuredClone(plotData)
    return {plotData, error}
}

export const relativeData = (plotData: any, xValues: any, xProcessing: any, yValues: any, yProcessing: any, zValues: any, zProcessing: any, axisFiltersState: FilterState, isPathwayMode?: boolean, heatmapKeepIfAnyMatchBool?: boolean, heatmapKeepIfAnyMatchAxisData?: any) => {
    let error = ''
    if (xProcessing && xProcessing.processingMode === 'relative' && xProcessing.references !== undefined && !!xProcessing.references.length){
        let { plotData: relativeXPlotData, error: relativeXError } = calculateRelativePlotData(plotData, xProcessing.references, xProcessing.hideReference, xProcessing.relativeUnits, xValues, xProcessing.groupBy, axisFiltersState, 'X-Axis Data')
        if (relativeXError) {
            error = relativeXError
        }
        // plotData = relativeXPlotData
        // Filter in here because we only filter if relative mode is applied
        plotData = filterAxis(axisFiltersState, relativeXPlotData, 'relative', isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData);
    }
    else if (yProcessing && yProcessing.processingMode === 'relative'  && yProcessing.references !== undefined && !!yProcessing.references.length){
        let { plotData: relativeYPlotData, error: relativeYError } = calculateRelativePlotData(plotData, yProcessing.references, yProcessing.hideReference, yProcessing.relativeUnits, yValues, yProcessing.groupBy, axisFiltersState, 'Y-Axis Data')
        if (relativeYError) {
            error = relativeYError
        }
        // plotData = relativeYPlotData
        plotData = filterAxis(axisFiltersState, relativeYPlotData, 'relative', isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData);
    }
    else if (zProcessing && zProcessing.processingMode === 'relative'  && zProcessing.references !== undefined && !!zProcessing.references.length){
        let { plotData: relativeZPlotData, error: relativeZError } = calculateRelativePlotData(plotData, zProcessing.references, zProcessing.hideReference, zProcessing.relativeUnits, zValues, zProcessing.groupBy, axisFiltersState, 'Z-Axis Data')
        if (relativeZError) {
            error = relativeZError
        }
        // plotData = relativeZPlotData
        plotData = filterAxis(axisFiltersState, relativeZPlotData, 'relative', isPathwayMode, heatmapKeepIfAnyMatchBool, heatmapKeepIfAnyMatchAxisData);
    }
    return {plotData, error}
}

const rms = (values: number[]) => {
    const squaredNumbers = values.map(num => num ** 2);
    const sumOfSquares = squaredNumbers.reduce((sum, num) => sum + num, 0);
    const meanOfSquares = sumOfSquares / values.length;
    const rootOfMeanSquares = Math.sqrt(meanOfSquares);
    return rootOfMeanSquares;

}

const median = (values: number[]) => {
    if (values.length === 0) {
    throw new Error('Input array is empty');
    }

    // Sorting values, preventing original array
    // from being mutated.
    values = [...values].sort((a, b) => a - b);

    const half = Math.floor(values.length / 2);

    return (values.length % 2
        ? values[half]
        : (values[half - 1] + values[half]) / 2
    );
}


/* 
 * Geometric mean calcution using the average of logs method. 
 * Usually, geo mean is calculated as the (a_0 * a_1 * a_2, ..., * a_n)^1/n 
 * This is method is prone to integer overflow. Thus we implemented it as such:
 * antilog(((log(1) + log(2) + . . . + log(n))/n)
 * Where antilog is the reverse of log. In our case, log is the natural log, and antilog is x^e
 */
const geoMean = (values: number[]) => {
    let sum = 0;
    
    // Compute the sum of the ln of all values
    for (let i = 0; i < values.length; i++) {
        sum = sum + Math.log(values[i]);
    }
    // compute the average of the logs
    sum = sum / values.length;
    
    // return the antilog of the average of the logs
    return Math.exp(sum); 
}

const gep = async (values: number[], genes: string[], pathwayGenes: string[]) => {


    // Call stats gep api
    const data = {
        'data': {
            'log2FC': values,
            'gene': genes
        },
        'operation': {
            'name':'gep',
            'anchor_pathways': pathwayGenes
        }
    }
    const response: Promise<GESResult[]> = (axios.post(`/tumors/api/v1/stats`, data, {headers: {"X-CSRFToken": getCookie("csrftoken")}})).then(res => res.data)
    
    const result = await response;
    // console.log("GEP Result", result);
    return result[0].normalized_score;
}

const multiSampleGes = async (gesData: { [key: string]: { gene: string[]; log2FC: number[]; pathwayGenes: string[] }}): Promise<MultiGesResult> => {
    
    const response: Promise<MultiGesResult> = (axios.post(`/tumors/api/v1/stats`, {'data': gesData, 'operation': {'name': 'bulk_ges'}}, {headers: {"X-CSRFToken": getCookie("csrftoken")}})).then(res => res.data);
    return response;
}


const calculatePathwayData = async (plotData: any, categories: any, pathwayScore: string, values: any, pathways: Groups, pathwayOrder: number[], axisName: string) => {
    let error = ''
    plotData = structuredClone(plotData)
    categories = structuredClone(categories)
    if (Object.keys(pathways).length === 0){
        return {plotData, error:'Please Select a Pathway'}
    }

    let gesDict : MultiGesResult = {};
    const GEP_CALC_MAX = 2000;
    if (pathwayScore === 'ges') {
        // Precompute GES for all pathways to avoid redundant API calls
        const gesData : {[key: string]: {gene: string[], log2FC: number[], pathwayGenes: string[]}} = {};
        let rowID = 0;
        console.log("length check", plotData.length * pathwayOrder.length);
        if (plotData.length * pathwayOrder.length > GEP_CALC_MAX) {
            return {plotData, error: 'GES calculation too large. Please reduce the number of samples or pathways.', categories: {}};
        }
        for (let data of plotData){
            for (let vt in values){
                for (let value of values[vt].values){
                    const allValues: number[] = [];
                    const allGenes: string[] = [];
                    for (let datumIndex in data[vt]){
                        if (!Object.keys(data[vt][datumIndex]).includes('Gene')){
                            error = 'Gene column not found in data. Please add Gene to the group by columns to enable pathway mode.'
                        }   
                        const gene = data[vt][datumIndex]['Gene'];
                        const geneValue = data[vt][datumIndex][value]
                        allValues.push(geneValue);
                        allGenes.push(gene);
                    }
                    for (let id of pathwayOrder) {
                        const pathway = pathways[id];
                        const pathwayKey = pathway.name + '|' + vt + '|' + value + '|' + rowID;
                        if (!(pathwayKey in gesDict)) {
                            gesData[pathwayKey] = {'gene': allGenes, 'log2FC': allValues, 'pathwayGenes': pathway.values};
                        }
                    }
                }
            }
            rowID += 1;
        }

        gesDict = await multiSampleGes(gesData); 
    }

    let rowID = 0;
    for (let data of plotData){
        for (let vt in values){
            for (let value of values[vt].values){
                const pathwayBuckets: {[id: number]: number[]} = {}
                const allValues: number[] = [];
                const allGenes: string[] = [];
                for (let datumIndex in data[vt]){
                    if (!Object.keys(data[vt][datumIndex]).includes('Gene')){
                        error = 'Gene column not found in data. Please add Gene to the group by columns to enable pathway mode.'
                    }   
                    const gene = data[vt][datumIndex]['Gene'];
                    const geneValue = data[vt][datumIndex][value]
                    // allValues.push(geneValue);
                    // allGenes.push(gene);
                    for (let id of pathwayOrder) {
                        const pathway = pathways[id];
                        if (pathway.values.includes(gene)) {
                            if (!(id in pathwayBuckets)) {
                                pathwayBuckets[id] = [];
                            }
                            pathwayBuckets[id].push(geneValue)
                        }
                    }
                }
                data[vt] = [];
                let geneCatAxis = undefined;
                for (let axis of ['x', 'y', 'z']) {
                    if (categories[axis]?.[vt]?.['Gene'] !== undefined) {
                        geneCatAxis = axis;
                    }
                }
                if (geneCatAxis !== undefined) {
                    categories[geneCatAxis][vt]['Gene'] = [];
                }
                for (let id of pathwayOrder) {
                    const pathway = pathways[id];
                    if (geneCatAxis !== undefined) {
                        categories[geneCatAxis][vt]['Gene'].push(pathway.name)
                    }
                    const pathwayValues = pathwayBuckets[id] || [];
                    if (pathwayValues.length > 0) {
                        let pathwayScoreValue = 0;
                        if (pathwayScore === 'mean') {
                            pathwayScoreValue = pathwayValues.reduce((a, b) => a + b) / pathwayValues.length;
                        } else if (pathwayScore === 'median') {
                            pathwayScoreValue = median(pathwayValues);
                        } else if (pathwayScore === 'max') {
                            pathwayScoreValue = Math.max(...pathwayValues);
                        } else if (pathwayScore === 'min') {
                            pathwayScoreValue = Math.min(...pathwayValues); 
                        } else if (pathwayScore === 'rms') { 
                            pathwayScoreValue = rms(pathwayValues);
                        } else if (pathwayScore === 'geomean') {
                            pathwayScoreValue = geoMean(pathwayValues);
                        } else if (pathwayScore === 'sum') {
                            pathwayScoreValue = pathwayValues.reduce((a, b) => a + b);
                        } else if (pathwayScore === 'ges') {
                            const gesKey = pathway.name + '|' + vt + '|' + value + '|' + rowID;
                            const normalized_score = gesDict[gesKey].raw_score;
                            pathwayScoreValue = normalized_score;
                        }
                        else {
                            return {plotData, error: 'Pathway Score ' + pathwayScore + ' not supported yet. Please select another.'}
                        }
                        data[vt].push({[value]: pathwayScoreValue, 'Gene': pathway.name});
                    }
                }
            }
        }
        rowID += 1;
    }
    return {plotData, error, categories}
}

export const pathwayData = async (plotData: any, categories: any, xValues: any, xProcessing: any, yValues: any, yProcessing: any, zValues: any, zProcessing: any, pathways: Groups, pathwayOrder: number[]) => { 
    let error = ''
    if (xProcessing && xProcessing.pathwayMode && xProcessing.pathwayScore !== undefined && Object.keys(xValues).length > 0){
        let { plotData: pathwayXPlotData, error: pathwayXError, categories: pathwayXCats} = await calculatePathwayData(plotData, categories, xProcessing.pathwayScore, xValues, pathways, pathwayOrder, 'X-Axis Data')
        if (pathwayXError) {
            error = pathwayXError
        }
        plotData = pathwayXPlotData
        categories = pathwayXCats
    }
    else if (yProcessing && yProcessing.pathwayMode && yProcessing.pathwayScore !== undefined && Object.keys(yValues).length > 0){
        let { plotData: pathwayYPlotData, error: pathwayYError, categories: pathwayYCats } = await calculatePathwayData(plotData, categories, yProcessing.pathwayScore, yValues, pathways, pathwayOrder, 'Y-Axis Data')
        if (pathwayYError) {
            error = pathwayYError
        }
        plotData = pathwayYPlotData
        categories = pathwayYCats
    }
    else if (zProcessing && zProcessing.pathwayMode && zProcessing.pathwayScore !== undefined && Object.keys(zValues).length > 0){
        let { plotData: pathwayZPlotData, error: pathwayZError, categories: pathwayZCats } = await calculatePathwayData(plotData, categories, zProcessing.pathwayScore, zValues, pathways, pathwayOrder, 'Z-Axis Data')
        if (pathwayZError) {
            error = pathwayZError
        }
        plotData = pathwayZPlotData
        categories = pathwayZCats
    }
    return {plotData, error, categories}
}

export const buildGroupByDict = (plotData: any, groupByColumns: any) => {

    let groupDict: any = {'': plotData};

    for (let groupByColumn of groupByColumns) {
        let newDict: any = {}
        let [first, second] = groupByColumn.split('|')

        for (let key in groupDict) {
            let newKey = key
            if (newKey) {
                newKey += '|'
            }
            let plotItems = groupDict[key]

            for (let plotItem of plotItems) {
               
                let category = ''

                // handle simple group by case
                if (!second) {
                    category = plotItem[first]
                    let categoryKey = newKey + category
                    if (!(categoryKey in newDict)) {
                        newDict[categoryKey] = []
                    }
                    newDict[categoryKey].push(plotItem)

                // handle nested group by case
                } else {
                    let subItemDict: any = {}
                    let subItem = plotItem[first]
                    if (!subItem) {
                        continue
                    }
                    for (let subCategory of subItem) {
                        let subCategoryValue = subCategory[second]
                        if (!(subCategoryValue in subItemDict)) {
                            subItemDict[subCategoryValue] = []
                        }
                        subItemDict[subCategoryValue].push(subCategory)
                    }
                    for (let subCategoryKey in subItemDict) {
                        let subCategoryDictKey = newKey + subCategoryKey
                        if (!(subCategoryDictKey in newDict)) {
                            newDict[subCategoryDictKey] = []
                        }
                        let plotItemToPush = JSON.parse(JSON.stringify(plotItem))
                        plotItemToPush[first] = subItemDict[subCategoryKey]
                        if (!(subCategoryDictKey in newDict)) {
                            newDict[subCategoryDictKey] = []
                        }
                        newDict[subCategoryDictKey].push(plotItemToPush)
                    }
                }
            }
        }
        groupDict = newDict
    }

    return groupDict
}

export const buildGroupByDictGPT = (plotData: any[], groupByColumns: string[]) => {
    let groupDict = new Map<string, any[]>([['', plotData]]);

    for (const groupByColumn of groupByColumns) {
        const newDict = new Map<string, any[]>();
        const [first, second] = groupByColumn.split('|');

        for (const [key, plotItems] of groupDict.entries()) {
            const baseKey = key ? `${key}|` : '';

            for (const plotItem of plotItems) {
                if (!second) { // Simple grouping
                    const categoryKey = `${baseKey}${(plotItem[first] !== undefined) ? plotItem[first] : ''}`;
                    if (!newDict.has(categoryKey)) newDict.set(categoryKey, []);
                    newDict.get(categoryKey)!.push(plotItem);
                } else if (plotItem[first] !== undefined) { // Nested grouping
                    const subItemDict = new Map<string, any[]>();
                    for (const subCategory of plotItem[first]) {
                        const subCategoryValue = subCategory[second];
                        if (subCategoryValue === undefined || subCategoryValue === null) continue;

                        if (!subItemDict.has(subCategoryValue)) subItemDict.set(subCategoryValue, []);
                        subItemDict.get(subCategoryValue)!.push(subCategory);
                    }

                    for (const [subCategoryKey, subItems] of subItemDict.entries()) {
                        const nestedKey = `${baseKey}${subCategoryKey}`;
                        const plotItemCopy = { ...plotItem, [first]: subItems }; // Shallow copy only
                        if (!newDict.has(nestedKey)) newDict.set(nestedKey, []);
                        newDict.get(nestedKey)!.push(plotItemCopy);
                    }
                }
            }
        }
        groupDict = newDict
    }


    const result: any = {};
    for (const [key, value] of groupDict.entries()) {
        result[key] = value;
    }
    // console.log("Group by dict result:", structuredClone(result));
    return result;
};

export const groupPlotData = (
    plotData: any[],
    groupByColumns: string[],
    _axisItems?: any,
    values?: any,
    aggregationMethod?: string,
    drop: boolean = true,
    axisFiltersState: FilterState = {},
    axisName: string = 'X-Axis Data',
    indexName: string = '0',
    sortOrder: string[] = []
  ) => {
    let startTotal = performance.now();
    if (!groupByColumns || groupByColumns.length === 0) {
      return {plotData, error: ''};
    }
    let startTooBigCheck = performance.now()
    groupByColumns = [
        ...sortOrder,
        ...groupByColumns.filter(item => !sortOrder.includes(item))
      ];

    let tooBig = false

    if (groupByColumns.length > 0) {
        
        for (let key of groupByColumns) {
            let [category, subcategory] = key.split('|')
            let matchIndex: number | undefined = undefined;

            let temp = 0;
            for (let filterKey in axisFiltersState){
                let filterCategory = axisFiltersState[filterKey].versionType
                let filterSubcategory = axisFiltersState[filterKey].column
                if (category === filterCategory && subcategory === filterSubcategory){
                    matchIndex = temp;
                    break; 
                }
                temp += 1
            }

            if (matchIndex === undefined) {
                if (subcategory) {
                    // tooBig = true
                }
            } else {
                // if (axisFiltersState[matchIndex].value.length > 100) {
                //     tooBig = true
                // }
            }
        }
    }

    if (tooBig) {
        return {plotData: plotData, error: 'Too many items to group by. Consider adding a filter.'};
    }
    let endTooBigCheck = performance.now()
    let result: any = {};
    let startBuild = performance.now()
    const groupDict = buildGroupByDictGPT(plotData, groupByColumns);
    // console.log(groupDict)
    let endBuild = performance.now()

    let startAgg = performance.now()

    let filterDataKeys: string[] = []
    for (let filterKey in axisFiltersState){
        const filter = axisFiltersState[filterKey];
        if (filter.type === 'numeric'){
            let filterDataKey = filter.versionType;
            let filterColumn = filter.column;
            if (filterColumn){
                filterDataKey += '|' + filterColumn
            }
            filterDataKeys.push(filterDataKey)          
        }
    }

    const axisItems = structuredClone(_axisItems);
    // console.log("Filter data keys", filterDataKeys)
    // console.log("Axis items", axisItems)

    for (let groupKey in groupDict) {
      const groupData = groupDict[groupKey];
      result[groupKey] = {};
  
      // Determine the data keys to iterate over
      const dataKeys = axisItems ? Object.keys(axisItems) : Object.keys(groupData[0]);
      
      for (let filterDataKey of filterDataKeys){

        const [vt, col] = filterDataKey.split('|')
        if (axisItems[vt] && !axisItems[vt].values.includes(col)){
            axisItems[vt].values.push(col);
        }
      }

      // Iterate over each data key
      for (let dataKey of dataKeys) {
        let valuesArray, aggregationMethodToUse;
        
        if (axisItems) {
          valuesArray = axisItems[dataKey].values;
          aggregationMethodToUse = axisItems[dataKey].aggregationMethod;
        } else {
          valuesArray = values;
          aggregationMethodToUse = aggregationMethod;
        }
  
        // Initialize the result object for the current data key
        result[groupKey][dataKey] = {};

        // Iterate over each value key and aggregate the values
        for (let valueKey of valuesArray) {
            let values : number[] = [];
            for (let item of groupData) {
                if (item[dataKey] !== undefined && item[dataKey].constructor.name === "Array") {
                    let newValues: number[] = item[dataKey].map((k: any) => Number(k[valueKey]))
                    values = values.concat(newValues)
                    //   for (let k of item[dataKey]) {
                    //     values.push(Number(k[valueKey]));
                    //   }
                }
            }
  
          values = values.filter((value: any) => !isNaN(value));
          let aggregatedValue;
          if (aggregationMethodToUse === 'mean') {
            aggregatedValue = values.reduce((sum: number, value: number) => sum + value, 0) / values.length;
          } else if (aggregationMethodToUse === 'median') {
            const sortedValues = values.sort((a: number, b: number) => a - b);
            const mid = Math.floor(sortedValues.length / 2);
            aggregatedValue = sortedValues.length % 2 !== 0 ? sortedValues[mid] : (sortedValues[mid - 1] + sortedValues[mid]) / 2;
          } else if (aggregationMethodToUse === 'max') {
            aggregatedValue = Math.max(...values);
          } else if (aggregationMethodToUse === 'min') {
            aggregatedValue = Math.min(...values);
          } else if (aggregationMethodToUse === 'sum') {
            aggregatedValue = values.reduce((sum: number, value: number) => sum + value, 0);
          } else if (aggregationMethodToUse === 'count'){
            aggregatedValue = values.length
          }
          result[groupKey][dataKey][valueKey] = aggregatedValue;
        }
      }
    }
    // let groupDictCopy = structuredClone(groupDict)
    let endAgg = performance.now()
    // console.log("Result", structuredClone(result))
    let startFinal = performance.now()
    let uniqueItems: any[] = [];

    let firstLoopTime = 0
    let secondLoopTime = 0
    let thirdLoopTime = 0

    for (let plotDataKey in groupDict) {
        let firstItem = groupDict[plotDataKey][0]
        // let firstItem = structuredClone(newPlotDataItem[0])
        let matchingResult;

        let groupByDict: any = {}
        let startFirst = performance.now()
        for (let column of groupByColumns) {
            let splitColumn = column.split('|')
            groupByDict[splitColumn[0]] = splitColumn[1]
        }
        let endFirst = performance.now()
        firstLoopTime += endFirst - startFirst

        let startSecond = performance.now()
        for (let firstOrder in firstItem) {
            if (!Object.keys(groupByDict).includes(firstOrder)) {
                firstItem[firstOrder] = 'Grouped'
            }
        }

        if (plotDataKey in result) {
            matchingResult = result[plotDataKey]
        }
        let endSecond = performance.now()
        secondLoopTime += endSecond - startSecond

        let startThird = performance.now()

        for (let key in matchingResult) {
            if (key in firstItem) {
                let additionalInfo: any = {}
                if (firstItem[key].length !== 0) {
                    if (key in groupByDict) {
                        let additionalKeys: any[] = [...groupByDict[key], ...groupByColumns.map(col => col.split('|')).filter(pair => pair[0] === key && pair[1] !== undefined).map(pair => pair[1])];
                        for (let additionalKey of additionalKeys) {
                            if (additionalKey in firstItem[key][0]) {
                                additionalInfo[additionalKey] = firstItem[key][0][additionalKey]
                            }
                        }
                    }
                }
                firstItem[key] = [Object.assign({}, matchingResult[key], additionalInfo)] //[{...matchingResult[key], ...additionalInfo}] //
                // firstItem[key] = [{...matchingResult[key], ...additionalInfo}] // //
                
            }
        }
        let endThird = performance.now()
        thirdLoopTime += endThird - startThird
        uniqueItems.push(firstItem)
    }

    // console.log("First loop total: ", firstLoopTime, 'ms')
    // console.log("Second loop total: ", secondLoopTime, 'ms')
    // console.log("Third loop total: ", thirdLoopTime, 'ms')

    let endFinal = performance.now()
    let endTotal = performance.now()
    // console.log("Unique Items", uniqueItems)
    // console.log("Total group by time: ", endTotal - startTotal, 'ms')
    // console.log("Too big check: ", endTooBigCheck - startTooBigCheck, 'ms')
    // console.log("Build step: ", endBuild - startBuild, 'ms')
    // console.log("Aggregation step: ", endAgg - startAgg, 'ms')
    // console.log("Final step: ", endFinal - startFinal, 'ms')
    // console.log("Output group by", structuredClone(uniqueItems));
    return {plotData: uniqueItems, error: null};
}


// Looks like this function has been unused for a while. Consider removing it if it's not needed.
// Also if you use it, please make it strongly typed.
// TL: I believe the replacement function is generateCategoricalPlotDataDict
export const processCategories = (zValues: any, categorical: any, plotData: any, axisFiltersState: any, xAggregation: any, yAggregation: any) => {

    let indexColumn: any = undefined
    let otherColumn: any = undefined
    let bothIndex = false

    let xDepth = checkDictionaryDepthRecursive(categorical['x'])
    let yDepth = checkDictionaryDepthRecursive(categorical['y'])
    
    if (xDepth === 1) {
        indexColumn = 'x'
        otherColumn = 'y'
    } 
    else if (yDepth === 1) {
        indexColumn = 'y'
        otherColumn = 'x'
    }

    if (xDepth === 1 && yDepth === 1) {
        indexColumn = 'y'
        otherColumn = 'x'
        bothIndex = true
    }
    
    let toUse = zValues
    let dataDict: {[itemColumnGroup: string]: {[itemColumn: string]: {[category: string]: any[]}}} = {}

    if (!indexColumn || !otherColumn || !categorical || !(indexColumn in categorical) || !(otherColumn in categorical)) {
        return dataDict
    }

    for (let plotItem of plotData) {
        let updatedPlotItem = filterAxis(axisFiltersState, [plotItem], 'cat')[0] // meow
        let indexCategory = Object.keys(categorical[indexColumn]).map((col: any) => updatedPlotItem[col]).join(' - ')
        for (let versionType of Object.keys(toUse)) {
            if (!(versionType in updatedPlotItem)) {
                continue
            }
            if (!(versionType in dataDict)) {
                dataDict[versionType] = {}
            }

            let categoryDict = categorical[otherColumn]
            for (let secondaryCategory of Object.keys(categoryDict)) {
                if (bothIndex) {
                    let itemCategory = Object.keys(categorical[otherColumn]).map((col: any) => updatedPlotItem[col]).join(' - ')
                    for (let plottedValue of toUse[versionType]['values']) {
                        if (Array.isArray(updatedPlotItem[versionType])) {
                            let valueList = (updatedPlotItem[versionType] as SubDataRow[]).map((item: any) => item[plottedValue])
                            if (!(itemCategory in dataDict[versionType])) {
                                dataDict[versionType][itemCategory] = {}
                            }
                            if (!(indexCategory in dataDict[versionType][itemCategory])) {
                                dataDict[versionType][itemCategory][indexCategory] = []
                            }

                            dataDict[versionType][itemCategory][indexCategory].push(...valueList)
                        }
                    }
                } else {
                    for (let secondaryCategoryKey of Object.keys(categoryDict[secondaryCategory])) {
                        for (let plottedValue of toUse[versionType]['values']) {
                            if (Array.isArray(updatedPlotItem[versionType])) {
                                for (let categoryName of categoryDict[secondaryCategory][secondaryCategoryKey].reverse()) {
                                    for (let plotDataKey of (updatedPlotItem[versionType] as SubDataRow[])) {
                                        let plotCategoryName = plotDataKey[secondaryCategoryKey]
                                        if (plotCategoryName === categoryName) {
                                            
                                            if (!(categoryName in dataDict[versionType])) {
                                                dataDict[versionType][categoryName] = {}
                                            }

                                            if (!(indexCategory in dataDict[versionType][categoryName])) {
                                                dataDict[versionType][categoryName][indexCategory] = []
                                            }

                                            dataDict[versionType][categoryName][indexCategory].push(plotDataKey[plottedValue]) 
                                            continue
                                        }  

                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    return dataDict 
}


export const filterCategories = (categorical: any, filtersState: OldFilterState) => {
    if (Object.keys(filtersState).length === 0) {
        return categorical
    }

    let filterCategories = JSON.parse(JSON.stringify(categorical));

    for (let key in filtersState) {
        let stateValues = Object.keys(filtersState[key]).map((item: any) => filtersState[key][item].value)
        if (stateValues.length === 0) {
            continue
        }
        let splitKey = key.split('|')
        let axis = splitKey[0]
        let category = splitKey[1]
        let subcategory = splitKey[2]
        if (axis in categorical) {
            if (category in categorical[axis]) {
                if (subcategory in categorical[axis][category]) {
                    filterCategories[axis][category][subcategory] = stateValues
                } 
            } 
        } 
    }
    return filterCategories
}

// Function to identify and remove common parts from labels, ensuring at least one part remains
export const removeCommonParts = (labels: string[]): string[] => {
    if (labels.length <= 1) { // If there's only one label or none, return as is
        return labels
    }
    const splitLabels = labels.map(label => label.split(" - "));

    // Identify common parts
    let commonParts = splitLabels[0].filter((part, index) => 
        splitLabels.every(labelParts => labelParts[index] === part));

    // Ensure that at least one part of each label remains
    const processedLabels = splitLabels.map(parts => {
        const nonCommonParts = parts.filter(part => !commonParts.includes(part));
        // If removing common parts would leave an empty label, keep one of the common parts
        if (nonCommonParts.length === 0 && parts.length > 1) {
            return parts.slice(0, parts.length - 1).join(" - "); // Keep all but the last common part
        }
        return nonCommonParts.join(" - ");
    });

    return processedLabels;
};


export const generateBoxPlot = (dataDict: any, categoryDict: any, xValues: any, subplotIndex: number, availableColors: string[], plotConfig: PlotConfig, colorIndex: number,  plotPvalues: PValueDict[] | undefined, sharedX: boolean, colorOverrideMap: Record<string, string>) => {
    const boxplotPointMax = 10000;
    let traces = []

    // const overrideColors = new Set(Object.values(colorOverrideMap));
    // const includeOverride = overrideColors.size >= Object.values(defaultColorMap).length - 4; 
    // const availableColors = (Object.values(defaultColorMap) as string[]).filter(col => !overrideColors.has(col) || includeOverride) as string[];
    // console.log("dataDict: ", dataDict);
    // console.log("categoryDict: ", categoryDict);
    console.log("Override map",     colorOverrideMap);
    console.log("available colors", availableColors)
    // console.log("Object.keys(categoryDict).length: ", Object.keys(categoryDict).length);
    let totalPoints = 0;
    let trace_index = 1;
    let scatter_trace_index = 1;
    // let colorIndex = 0;
    for (let plotKey in dataDict) {
        for (let plotValue in dataDict[plotKey]) {
            // Now loop through categories and create separate traces
            for (let category in dataDict[plotKey][plotValue]) {
                if (dataDict[plotKey][plotValue][category] !== undefined) {
                    let values = dataDict[plotKey][plotValue][category].map((item: any) => item.value)
                    // let pvalue: number | string | undefined = plotConfig.pvalue && plotPvalues !== undefined && plotPvalues.length > 0 ? getPvalueFromDict(plotKey, plotValue, category, plotPvalues[subplotIndex-1], plotConfig) : undefined
                    let hovertexts = dataDict[plotKey][plotValue][category].map((point: any, index: number) => {
                        // console.log("Point: ", point);
                        let { value, Treatment_and_Dose: treatment, Timepoint: timepoint, 'Sample Title': sample, channel_id: channel, pvalue, ...extraKeys } = point;
                        // console.log("Extra keys", extraKeys);
                        let valueText = typeof value === 'number' ? value.toFixed(2) : value;
                        let pval_string = getPvalueHoverString(pvalue, plotConfig);

                        let extraInfo = Object.entries(extraKeys)
                          .map(([key, value]) => `${key}: ${value}`)
                          .join('<br />');
                    
                        return `Value: ${valueText}<br />Treatment: ${treatment}<br />Timepoint: ${timepoint}<br />Sample: ${sample}<br />Channel: ${channel}${pval_string}${extraInfo ? '<br />' + extraInfo : ''}`;
                      });

                    const unMappedCat = category; 
                    if (category in categoryDict) {
                        category = categoryDict[category]
                    }

                    let name = category;
                    let emptyTraceMode = false;
                    if (values.length === 0 && sharedX){
                        values = [NaN]
                        emptyTraceMode = true;
                    }
                    totalPoints += values.length;
                    if (plotConfig.boxpoints === 'all' && totalPoints > boxplotPointMax) {
                        throw Error("Too many points to plot. Please filter the data further.")
                    }
                    let trace: Trace = {
                        x: Object.keys(xValues).length > 0 ? values : ((plotConfig.boxpoints === 'all') ? Array(values.length).fill(trace_index):category),
                        // x: Array(values.length).fill(trace_index),
                        y: Object.keys(xValues).length > 0 ? ((plotConfig.boxpoints === 'all') ? Array(values.length).fill(trace_index):category) : values,
                        boxmean: plotConfig.boxMeanLine,
                        type: (emptyTraceMode && sharedX) ? 'bar': 'box', // Box in plotly show blank if the values are empty, use bar instead
                        boxpoints: plotConfig.boxpoints,
                        // boxpoints: 'all',
                        orientation: Object.keys(xValues).length > 0 ? 'h' : 'v',
                        name: name,
                        showlegend: plotConfig.showLegend,
                    }
                    if (plotConfig.fixedColorMode) {
                        trace.marker = {color: plotConfig.fixedColor};
                    } else if (colorOverrideMap && name in colorOverrideMap) {
                        trace.marker = {color: colorOverrideMap[name]};
                    } else if (colorOverrideMap && unMappedCat in colorOverrideMap) {
                        trace.marker = {color: colorOverrideMap[unMappedCat]};
                        colorOverrideMap[name] = colorOverrideMap[unMappedCat]; // Store the color in the override map for future use
                    } 
                    // else if (plotConfig.colorMap) {
                    //     trace.marker = {color: plotConfig.colorMap[trace_index-1]};
                    //     colorOverrideMap[name] = plotConfig.colorMap[trace_index-1]; // Store the color in the override map for future use
                    // }
                     else {
                        trace.marker = {color: availableColors[colorIndex % availableColors.length]};
                        if (!colorOverrideMap) {
                            colorOverrideMap = {}
                        }
                        colorOverrideMap[name] = availableColors[colorIndex % availableColors.length]; // Store the color in the override map for future use
                        colorIndex += 1;
                    }
                    
                    trace.hoverinfo = 'text';
                    trace.hovertext = hovertexts;
   
                    if (plotConfig.boxpoints && plotConfig.scatterColorBy && plotConfig.scatterColorBy !== '' && !emptyTraceMode) {
                        let scatter_trace: Trace = {
                            x: Array(values.length).fill(scatter_trace_index-0.4),
                            y: values,
                            type: 'scatter',
                            name: name + ' ',
                            mode: 'markers',
                            orientation: Object.keys(xValues).length > 0 ? 'h' : 'v',
                            showlegend: plotConfig.showLegend,
                        };
                        if (plotConfig.fixedColorMode) {
                            scatter_trace.marker = {color: plotConfig.fixedColor};
                        } else if (name in colorOverrideMap) {
                            scatter_trace.marker = {color: colorOverrideMap[name]};  
                        }else if (unMappedCat in colorOverrideMap) {
                            scatter_trace.marker = {color: colorOverrideMap[unMappedCat]};
                            colorOverrideMap[name] = colorOverrideMap[unMappedCat];
                        } 
                        //  else if (plotConfig.colorMap) {
                        //     scatter_trace.marker = {color: plotConfig.colorMap[scatter_trace_index-1]};
                        //     colorOverrideMap[name] = plotConfig.colorMap[scatter_trace_index-1]; // Store the color in the override map for future use
                        // }
                         else {
                            scatter_trace.marker = {color: availableColors[(colorIndex-1) % availableColors.length]};
                            colorOverrideMap[name] = availableColors[(colorIndex-1) % availableColors.length]; // Store the color in the override map for future use
                        }
                        scatter_trace.hoverinfo = 'text';
                        scatter_trace.hovertext = hovertexts;
                        traces.push(scatter_trace);
                    }
                    scatter_trace_index += 1;
                    trace_index += 1;
                    // Now push the trace for the box (so that it comes to the right or after the trace with the box points)
                    traces.push(trace)
                }
            }
        }
    }
    return traces
}

export const generateBarPlot = (dataDict: any, categoryDict: any, xValues: any, subplotIndex: number, availableColors: string[], plotConfig: PlotConfig, colorIndex: number, plotPvalues: PValueDict[] | undefined, sharedX: boolean, colorOverrideMap: Record<string, string>, plotErrorBars: ErrorBarDict[] | ErrorBarDict[][]) => {
    let trace_index = 0;
    let traces = [];
    // const overrideColors = new Set(Object.values(colorOverrideMap));
    // const includeOverride = overrideColors.size >= Object.values(defaultColorMap).length - 4; 
    // const availableColors = (Object.values(defaultColorMap) as string[]).filter(col => !overrideColors.has(col) || includeOverride) as string[];
    const subGroupColorMap: Record<string, string> = {}
    let groupKeyOrder: string[] = [];

    for (let plotKey in dataDict) {
        for (let plotValue in dataDict[plotKey]) {
            // Now loop through categories and create separate traces
            let catIndex = 0;
            for (let category in dataDict[plotKey][plotValue]) {
                if (dataDict[plotKey][plotValue][category] !== undefined) {
                    
                    const subGroups = dataDict[plotKey][plotValue][category].reduce((acc: any, point: any) => {

                        if (plotConfig.barMode !== 'none' && plotConfig.barGroupBy && plotConfig.barGroupBy !== '') {
                            let groupKey = point[plotConfig.barGroupBy.replace('Sample', 'Sample Title').replace('Treatment', 'Treatment_and_Dose').replace('Channel', 'channel_id').replace('Timepoint', 'Timepoint')];
                            if (!acc[groupKey]) { 
                                acc[groupKey] = [];
                            }
                            if (!groupKeyOrder.includes(groupKey)) {
                                groupKeyOrder.push(groupKey);
                                if (groupKey in colorOverrideMap) {
                                    subGroupColorMap[groupKey] = colorOverrideMap[groupKey];
                                }
                                else {
                                    subGroupColorMap[groupKey] = availableColors[colorIndex % availableColors.length];
                                    colorOverrideMap[groupKey] = subGroupColorMap[groupKey]; // Store the color in the override map for future use
                                }
                                colorIndex += 1; // Increment the color index for the next group regardless of whether it exists in the map
                            }
                            acc[groupKey].push(point);
                            
                        }
                        else {
                            if (!acc['']) {
                                acc[''] = [];
                                if (groupKeyOrder.length === 0) {
                                    groupKeyOrder.push('');
                                }
                            }
                            acc[''].push(point);
                        }
                        return acc;
                    }, {});
                    
                    // console.log("Subgroups: ", subGroups);
                    // console.log("GroupKeyOrder: ", groupKeyOrder);
                    
                    for (let groupKey of groupKeyOrder) {
                        let plottedCategory = category
                        if (plottedCategory in categoryDict) {
                            plottedCategory = categoryDict[category]
                        }
                        let name = plottedCategory;
                        if (subGroups[groupKey] === undefined || subGroups[groupKey].length === 0) {

                            let trace: Trace = {
                                x: Object.keys(xValues).length > 0 ? [NaN] : [plottedCategory], 
                                y: Object.keys(xValues).length > 0 ? [plottedCategory]: [NaN], 
                                type: 'bar',
                                boxpoints: undefined,
                                orientation: Object.keys(xValues).length > 0 ? 'h' : 'v',
                                name: plotConfig.barMode !== 'none' && plotConfig.barGroupBy && plotConfig.barGroupBy !== '' ? groupKey : name,
                                // barmode: plotConfig.barGroupBy ? 'stacked' : undefined,
                                // text: ['***'],
                                // textposition:'outside'
                            }
                            let matchingTrace = traces.find((t: any) => t.name === groupKey);
                            if (matchingTrace) {
                                if (Object.keys(xValues).length > 0 ){
                                    matchingTrace.x.push(NaN);
                                    matchingTrace.y.push(plottedCategory);      
                                }
                                else {
                                    matchingTrace.x.push(plottedCategory);
                                    matchingTrace.y.push(NaN);
                                }
                                // check if hovertext is array
                                if (Array.isArray(matchingTrace.hovertext)) {
                                    matchingTrace.hovertext.push('');
                                } else {
                                    matchingTrace.hovertext = [matchingTrace.hovertext || '', ''];
                                }
                                matchingTrace.marker.color = subGroupColorMap[groupKey];

                                if (plotConfig.errorBars && matchingTrace.error_y) {
                                    matchingTrace.error_y.array.push(NaN);
                                }
                                else if (plotConfig.errorBars) {
                                    matchingTrace.error_y = {array: [NaN], color: 'black'};
                                }
                            } else {
                                traces.push(trace);
                            }
                            // trace_index += 1;
                            continue;
                        }
                        let plotErrorBar: ErrorBarDict | undefined;
                        if (plotConfig.errorBars) {
                            if (!plotErrorBars || plotErrorBars.length === 0) {
                                throw Error("Error bars are enabled but no error bar data is available.");
                            }
                            if (Array.isArray(plotErrorBars[0])) {
                                if (subplotIndex-1 >= plotErrorBars.length) {
                                    throw Error("Error bars are enabled but no error bar data is available for this subplot.");
                                }
                            }
                            if (plotConfig.barMode === 'group' && plotConfig.barGroupBy && plotConfig.barGroupBy !== '') {
                                plotErrorBar = (plotErrorBars[subplotIndex-1] as ErrorBarDict[])[catIndex]
                            }
                            else {
                                plotErrorBar = plotErrorBars[subplotIndex-1] as ErrorBarDict
                            }
                            
                        }
                        let values = subGroups[groupKey].map((item: any) => item.value)
                        
                        let groupedHoverInfo = subGroups[groupKey].reduce((acc: any, point: any) => {
                            // console.log("Point: ", point);
                            // let { value, Treatment_and_Dose: treatment, Timepoint: timepoint, 'Sample Title': sample, channel_id: channel, pvalue, ...extraKeys } = point;
                            // console.log("Extra keys", point);
                            for (let key of Object.keys(point)) {
                                if (key in acc) {
                                    if (acc[key] !== point[key] && key !== 'value') {
                                        acc[key] = 'Grouped';
                                    }
                                }
                                else {
                                    acc[key] = structuredClone(point[key]);
                                }
                            }
                            return acc;
                        });
                        
                        let mean = Mean(values);
                        if (isNaN(mean) && !sharedX){
                            continue;
                        }

                        let stderr = plotErrorBar === undefined ? StandardError(values) : plotErrorBar[plotKey][plotValue][plotConfig.barMode !== 'none' && plotConfig.barGroupBy && plotConfig.barGroupBy !== ''? groupKey : category];
                        
                        

                        let { value, Treatment_and_Dose: treatment, Timepoint: timepoint, 'Sample Title': sample, channel_id: channel, pvalue, ...extraKeys } = groupedHoverInfo;
                        
                        pvalue = plotConfig.pvalue && plotPvalues !== undefined && plotPvalues.length > 0 ? getPvalueFromDict(plotKey, plotValue, plottedCategory, plotPvalues[subplotIndex-1], plotConfig) : undefined
                        let valueText = typeof mean === 'number' ? mean.toFixed(2) : mean;
                        let pval_string = getPvalueHoverString(pvalue, plotConfig);

                        let extraInfo = Object.entries(extraKeys)
                        .map(([key, value]) => `${key}: ${value}`)
                        .join('<br />');

                        if (plotConfig.errorBars) {
                            extraInfo += (`<br />Standard Error: ${stderr?.toFixed(2)}`)
                        }
                        let hovertext =  [`Value: ${valueText}<br />Treatment: ${treatment}<br />Timepoint: ${timepoint}<br />Sample: ${sample}<br />Channel: ${channel}${pval_string}${extraInfo ? '<br />' + extraInfo : ''}`];
                        
                        let trace: Trace = {
                            x: Object.keys(xValues).length > 0 ? [mean] : [plottedCategory], 
                            y: Object.keys(xValues).length > 0 ? [plottedCategory]: [mean], 
                            type: 'bar',
                            boxpoints: undefined,
                            orientation: Object.keys(xValues).length > 0 ? 'h' : 'v',
                            name: plotConfig.barMode !== 'none' && plotConfig.barGroupBy && plotConfig.barGroupBy !== ''? groupKey : name,
                            // barmode: plotConfig.barGroupBy ? 'stacked' : undefined,
                            // text: ['***'],
                            // textposition:'outside'
                        }
                        let text_trace: Trace = {
                            x: [plottedCategory],
                            y: [mean+stderr+(mean*0.05)],
                            type: 'scatter',
                            boxpoints: undefined,
                            orientation: Object.keys(xValues).length > 0 ? 'h' : 'v',
                            name: name,
                            text: [getPvalueAnnotationString(pvalue)],
                            textposition:'outside',
                            mode:'text'
                        }
                        let xPoint = category 
                        let yPoint = mean
                        
                        trace.hoverinfo = 'text';
                        // trace.hovertext = [`X: ${xPoint}<br />Y: ${typeof yPoint === 'number' ? yPoint.toFixed(2) : yPoint}` + getPvalueHoverString(pvalue, plotConfig)];;
                        trace.hovertext = hovertext;
                        if (plotConfig.fixedColorMode) {
                            trace.marker = {color: plotConfig.fixedColor};
                        } else if ((plotConfig.barMode !== 'none') && plotConfig.barGroupBy && plotConfig.barGroupBy !== '' && groupKey in subGroupColorMap) {
                            trace.marker = {color: subGroupColorMap[groupKey]};
                        } else if (plottedCategory in colorOverrideMap) {
                            trace.marker = {color: colorOverrideMap[plottedCategory]};
                        } else if (category in colorOverrideMap) {
                            trace.marker = {color: colorOverrideMap[category]};
                        } 
                        // else if (plotConfig.colorMap) {
                        //     trace.marker = {color: plotConfig.colorMap[trace_index]};
                        //     colorOverrideMap[category] = availableColors[trace_index];
                        // }
                         else {
                            trace.marker = {color: availableColors[colorIndex % availableColors.length]};
                            colorOverrideMap[category] = availableColors[colorIndex % availableColors.length];
                            colorIndex += 1;
                        }
                        trace.error_y = plotConfig.errorBars ? {array: plotConfig.onesidedErrorBars ? (mean > 0 ? [stderr] : [0]) : [stderr], arrayminus: mean > 0 ? [0] : [stderr], color: 'black',  symmetric: plotConfig.onesidedErrorBars ? false : true, thickness: plotConfig.onesidedErrorBars ? 1: undefined} : undefined;    
                        if (plotConfig.onesidedErrorBars) {
                            trace.marker.line = {width: 1, color: 'black'};
                        }

                        if (plotConfig.barMode !== 'none' &&  plotConfig.barGroupBy && plotConfig.barGroupBy !== '') { // merge bar traces that are in the same group
                            let matchingTrace = traces.find((t: any) => t.name === groupKey);
                            if (matchingTrace) {
                                if (Object.keys(xValues).length > 0 ){
                                    matchingTrace.x.push(mean);
                                    matchingTrace.y.push(plottedCategory);      
                                }
                                else {
                                    matchingTrace.x.push(plottedCategory);
                                    matchingTrace.y.push(mean);
                                }
                                // check if hovertext is array
                                if (Array.isArray(matchingTrace.hovertext)) {
                                    matchingTrace.hovertext.push(hovertext[0]);
                                } else {
                                    matchingTrace.hovertext = [matchingTrace.hovertext || '', hovertext[0]];
                                }
                                matchingTrace.marker.color = subGroupColorMap[groupKey];

                                if (plotConfig.errorBars && matchingTrace.error_y) {
                                    matchingTrace.error_y.array.push(stderr);
                                }
                                else if (plotConfig.errorBars) {
                                    matchingTrace.error_y = {array: [stderr], color: 'black'};
                                }
                            } else {
                                traces.push(trace);
                            }
                        }
                        else {
                            traces.push(trace);
                        }
                    }
                    // traces.push(text_trace)
                    trace_index += 1;
                }
                catIndex += 1;
            }
        }
    }
    // console.log("bar plot traces: ", traces);
    return traces
}

export const generateScatterPlot = (dataDict: any, categoryDict: any, xValues: any, subplotIndex: number,  availableColors: string[], plotConfig: any, colorIndex: number,  yValues: any, scatterMode?:string) => { 
    let traces = []
    const maxScatterPoints = 10000;
    if (scatterMode === undefined){
        scatterMode = 'markers';
    }
    let trace_index = 0;
    for (let plotKey in dataDict) {
        for (let plotValue in dataDict[plotKey]) {
            let dataPoints: any = []
            let categoryPoints: any = []
            
            let hoverPoints = [];

            for (let category in dataDict[plotKey][plotValue]) {
                for (let categoryItem of dataDict[plotKey][plotValue][category]) {
                    let { value, Treatment_and_Dose: treatment, Timepoint: timepoint, 'Sample Title': sample, channel_id: channel, ...extraKeys } = categoryItem;

                    dataPoints.push(value);
                    categoryPoints.push(category);

                    let valueText = typeof value === 'number' ? value.toFixed(2) : value;

                    let extraInfo = Object.entries(extraKeys)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br />');

                    hoverPoints.push(`Value: ${valueText}<br />Treatment: ${treatment}<br />Timepoint: ${timepoint}<br />Sample: ${sample}<br />Channel: ${channel}${extraInfo ? '<br />' + extraInfo : ''}`);
                }
            }

            categoryPoints = removeCommonParts(categoryPoints);
            let xPoints = Object.keys(xValues).length > 0 ? dataPoints : categoryPoints;
            let yPoints = Object.keys(yValues).length > 0 ? dataPoints : categoryPoints;
            if (xPoints.length > maxScatterPoints || yPoints.length > maxScatterPoints) {
                throw Error('Too many points to plot. Please filter the data to reduce the number of points.');
            }
            let name = plotKey + ' ' + plotValue;

            let trace: Trace = {
                x: xPoints,
                y: yPoints,
                type: 'scatter',
                boxpoints: undefined,
                orientation: Object.keys(xValues).length > 0 ? 'h' : 'v',
                name: name,
                hoverinfo: 'text', 
                mode: scatterMode
            }


            if (plotConfig.fixedColorMode) {
                trace.marker = {color: plotConfig.fixedColor};
            } else if (plotConfig.colorMap) {
                trace.marker = {
                    line: {color: plotConfig.colorMap[trace_index], width: 2.5},
                    fill: 'toself',
                    color: plotConfig.fillMap && plotConfig.fillMap[trace_index] == "true" ? plotConfig.colorMap[trace_index] : 'white',
                };
            } else {
                trace.marker = {color: '#4287f5'};
            }
            trace.marker.size = plotConfig.markerSize;
            trace.marker.symbol = plotConfig.symbolMap ? plotConfig.symbolMap[trace_index] : undefined;
            trace.hovertext = hoverPoints;

            traces.push(trace)
            trace_index += 1;
        }
    }
    // console.log("Scatter traces", traces);
    // console.log("color by Scatter traces", colorDataVsDataTrace(traces[0], plotConfig, scatterMode));
    return traces.length > 0 ? colorDataVsDataTrace(traces[0], plotConfig, scatterMode) : traces
}

export const generateHeatmap = (categorical:any, dataDict: DataDict) => {
    let mapping: any = {}
    let categoricalSet = new Set()

    // console.log("dataDict in generateHeatmap: ", dataDict);

    for (let plotKey in dataDict) {
        for (let plotValue in dataDict[plotKey]) {
            for (let category in dataDict[plotKey][plotValue]) {
    
                let mean = takeMeanofArray(dataDict[plotKey][plotValue][category])
                let combinedKey = plotValue
                let yDepth = checkDictionaryDepthRecursive(categorical['y'])
                
                if (categorical['y'] && yDepth === 1) {
                    if (!(category in mapping)) {
                        mapping[category] = {}
                    }
                    categoricalSet.add(combinedKey)
                    mapping[category][combinedKey] = mean
                } else { 
                    if (!(combinedKey in mapping)) {
                        mapping[combinedKey] = {}
                    }
                    categoricalSet.add(category)
                    mapping[combinedKey][category] = mean
                }
            }
        }
    }

    let y = Object.keys(mapping)
    let x = Array.from(categoricalSet) as string[]
    let z = []

    for (let key of y) {
        let row = []
        for (let col of x) {
            row.push(mapping[key][col])
        }
        z.push(row)
    }

    let trace = {
        x: x,
        y: y,
        z: z,
        type: 'heatmap',
        colorscale:[
            [0, '#3a4c80'],   // Color at the lowest end of the scale
            [0.5, 'white'],   // Color at the midpoint
            [1, '#c00000']    // Color at the highest end of the scale
        ]
    }
    return trace
}



export const generateHeatmapV2 = async (dataDict: DataDict, categoryDict: any, xValues: any, subplotIndex: number, availableColors: string[], plotConfig: PlotConfig, colorIndex: number, selectedItems: SelectedItems, loadingCallback: (s: string) => void) => {
   
    // console.log("processedDataList.dataDict: ", processedDataList[0].dataDict);

    let zmin = null;
    let zmax = null;

    // console.log("plotConfig: ", plotConfig);

    // Define appropriate zmin and zmax
     if (selectedItems) {
      const axisData = selectedItems['Z-Axis Data']?.[0]
      if (axisData) {
        if (axisData.processingMode === 'relative') {
            zmin = plotConfig.zmin_rel;
            zmax = plotConfig.zmax_rel;
        } else if (plotConfig.heatmapLog2) {
            zmin = plotConfig.zmin_log2;
            zmax = plotConfig.zmax_log2;
        } else {
            zmin = plotConfig.zmin;
            zmax = plotConfig.zmax;
        }
      }
    }

    // x and y for heatmap must be tagged as categorical in the UI, unless it's a standard categorical selection (i.e. Sample Title, Treatment and Dose, etc...)
    if (selectedItems === undefined || selectedItems['X-Axis Data'].length === 0 || selectedItems['Y-Axis Data'].length === 0 || selectedItems['Z-Axis Data'].length === 0){
        return []
    }
    const xAxisKeys = selectedItems['X-Axis Data'].map((x) => x.method == 'categorical' ? x.values[0] : x.name);
    const yAxisKeys = selectedItems['Y-Axis Data'].map((y) => y.method == 'categorical' ? y.values[0] : y.name);
    const zAxisKey = selectedItems['Z-Axis Data']?.[0]?.values[0];

    const default_colorscaleTitle = zAxisKey.length < 10 ? zAxisKey : zAxisKey.slice(0,10) + "...";

    // console.log("xAxisKey: ", xAxisKey);
    // console.log("yAxisKey: ", yAxisKey);

    let x: string[] = [];
    let y: string[] = [];
    let z: number[] = [];

    for (let plotKey in dataDict) {
        // console.log("plotKey: ", plotKey);
        for (let plotValue in dataDict[plotKey]) {
            // console.log("plotValue: ", plotValue);
            for (let category in dataDict[plotKey][plotValue]) {
                for (const dataPoint of dataDict[plotKey][plotValue][category]) {
                    // console.log("dataPoint: ", dataPoint);
                    let xv = xAxisKeys.map((key) => dataPoint[key]).join(' - ');
                    let yv = yAxisKeys.map((key) => dataPoint[key]).join(' - ');
                    x.push(categoryDict[xv] ?? xv);
                    y.push(categoryDict[yv] ?? yv);
                    z.push(dataPoint.value);
                    // console.log(`[x, y, z]: [${dataPoint[xAxisKey]}, ${dataPoint[yAxisKey]}, ${dataPoint.value}]`);
                }
            }
        }
    }
    // y = y.reverse()
    // console.log("Length of y: ", y.length);

    let reorderedY: string[] = [];
    let reorderedX: string[] = [];
    let reorderedZ2D: (number | null)[][] = [];
    
    
    // Find unique x and y values
    const xUnique = [...new Set(x)];
    const yUnique = [...new Set(y)].reverse(); // reverse sort order of y so values go top to bottom

    const xUniqueIndexMap = getIndexMapOfStrArray(xUnique);
    const yUniqueIndexMap = getIndexMapOfStrArray(yUnique);

    // console.log("yUnique: ", yUnique);

    // console.log("x: ", x);
    // console.log("y: ", y);
    // console.log("z: ", z);


    if (y.length > 0) {

        // // Reshape the flattened z data into a 2D matrix
        // const z2D: any[] = [];
        const numRows = yUnique.length;
        const numCols = xUnique.length;

        // for (let i = 0; i < numRows; i++) {
        //     z2D.push(z.filter((value, index) => index % numRows === i));
        // }
        // console.log("z2D: ", z2D);


        // Reshape z into a 2D matrix
        const z2D: (number | null)[][] = Array.from({ length: yUnique.length }, () => 
            Array(xUnique.length).fill(null)
        );


        const rowsToRemove: number[] = [];
        const colsToRemove: number[] = [];
        for (let i = 0; i < z.length; i++) {
            const xIndex = xUniqueIndexMap[x[i]];
            const yIndex = yUniqueIndexMap[y[i]];
            if (xIndex !== -1 && yIndex !== -1) {
                z2D[yIndex][xIndex] = z[i];
                
            }
        }
        if (plotConfig.heatmapHandleFiltered !== undefined && plotConfig.heatmapHandleFiltered !== 'none') {
            for (let i = 0; i < z2D.length; i++) {
                for (let j = 0; j < z2D[i].length; j++) {
                    if (z2D[i][j] === null) {
                        // Mark row and column for removal if remove nans is enabled
                        if (plotConfig.heatmapHandleFiltered === 'rows' && !rowsToRemove.includes(i)) {
                            rowsToRemove.push(i);
                        }
                        if (plotConfig.heatmapHandleFiltered === 'columns' && !colsToRemove.includes(j)) {
                            colsToRemove.push(j);
                        }
                    }
                }
            }
        }

        // Remove rows and columns in rowsToRemove and colsToRemove
        for (let i = rowsToRemove.length - 1; i >= 0; i--) {
            z2D.splice(rowsToRemove[i], 1);
            yUnique.splice(rowsToRemove[i], 1);
        }
        for (let i = colsToRemove.length - 1; i >= 0; i--) {
            for (let j = 0; j < z2D.length; j++) {
                z2D[j].splice(colsToRemove[i], 1);
            }
            xUnique.splice(colsToRemove[i], 1);
        }
        

        const yLabels = yUnique
        const xLabels = xUnique;


        if ((plotConfig.heatmapYcluster) || (plotConfig.heatmapXcluster)) {
            const clusterMax = 1000;
            if (checkForNulls(z2D)) {
                throw Error("Clustering is not supported for datasets with missing values. Please remove missing values and try again.");
            }
            if (yLabels.length < clusterMax && xLabels.length < clusterMax ) {
                // console.log("Clustering z2D: ", z2D);
                loadingCallback("Clustering...");
                const {rowOrder, colOrder} = await clusterAPI(z2D as number[][]);
                loadingCallback("Clustering done.");
                // console.log("Row Order: ", rowOrder);
                if (plotConfig.heatmapYcluster){
                    reorderedZ2D = rowOrder.map(i => z2D[i]);
                    reorderedY = rowOrder.map(i => yLabels[i]);
                }
                else {
                    reorderedY = yLabels;
                }
                if (plotConfig.heatmapXcluster){
                    // reorderedZ2D = reorderedZ2D.length > 0 ? reorderedZ2D.map(row => colOrder.map(j => row[j])) : colOrder.map(j => z2D.map(row => row[j]));
                    reorderedZ2D = reorderedZ2D.length > 0 ? reorderedZ2D.map(row => colOrder.map(j => row[j])) : z2D.map(row => colOrder.map(j => row[j]));
                    reorderedX = colOrder.map(j => xLabels[j]);
                }
                else {
                    reorderedX = xLabels;
                }

                if (reorderedZ2D.length === 0){
                    reorderedZ2D = z2D;
                }
            } else {
                throw Error("Clustering is not supported for datasets with more than " + clusterMax + " unique labels.");
            }
        } else {
            reorderedX = xLabels;
            reorderedY = yLabels;
            reorderedZ2D = z2D;
        }
    }

    // console.log("reorderedX: ", reorderedX);
    // console.log("reorderedY: ", reorderedY);
    // console.log("reorderedZ2D: ", reorderedZ2D);

    // Apply log2 transformation if needed
    if (plotConfig.heatmapLog2) {
        for (let i = 0; i < reorderedZ2D.length; i++) {
            for (let j = 0; j < reorderedZ2D[i].length; j++) {
                const value = reorderedZ2D[i][j];
                if (value !== null && value > 0) {
                    reorderedZ2D[i][j] = Math.log2(value);
                } else {
                    reorderedZ2D[i][j] = null; // Explicitly handle invalid cases
                }
            }
        }
    }
    // console.log("Final color scale", plotConfig.colorscale);
    // console.log("Final color scale mapped", colorScaleMap[plotConfig.colorscale as keyof ColorScaleMap]);

    let trace: Trace = {
        x: reorderedX,
        y: reorderedY,
        z: reorderedZ2D,
        // x: x,
        // y: y,
        // z: z,
        type: 'heatmap',
        name: '', 
        colorscale: colorScaleMap[plotConfig.colorscale as keyof ColorScaleMap],
        colorbar: {
            len: 0.5, // Set the vertical height to 50% of the plot height
            lenmode: 'fraction', // Interpret 'len' as a fraction
            thickness: 20, // Width of the colorbar in pixels
            thicknessmode: 'pixels', // Interpret 'thickness' in pixels
            visible: true, // Toggle visibility of the colorbar (true/false)
            outlinecolor: 'rgba(0,0,0,0)', // transparent
            title: {
                text: plotConfig.colorscaleTitle ? plotConfig.colorscaleTitle : default_colorscaleTitle,  // Title text for the colorbar
                side: 'top',  // Position the title above the colorbar
            },
        },
        zmin: zmin,
        zmax: zmax,
    }
    return [trace];
}



export const generateDataVsDataScatterPlot = (
    xPlotData: any,
    yPlotData: any, 
    xValues: any, 
    yValues: any,
    plotType: any,
    plotConfig: any,
) => {
    let xList = [];
    let yList = [];
    let x = [];
    let y = [];
    let z = [];
    let hoverText = [];
    let xFilterDict = {};
    let yFilterDict = {};
    
    // if (axisFiltersState) {
    //     // Filter dictionary keys to get only ones that have X-Axis Data in the string
    //     let xKeys = Object.keys(axisFiltersState).filter((key: any) => key.includes('X-Axis Data'));
    //     let yKeys = Object.keys(axisFiltersState).filter((key: any) => key.includes('Y-Axis Data'));
    
    //     // Create a dictionary with xKeys
    //     xFilterDict = xKeys.reduce((acc: any, key: any) => {
    //     acc[key] = axisFiltersState[key];
    //     return acc;
    //     }, {});
    
    //     // Create a dictionary with yKeys
    //     yFilterDict = yKeys.reduce((acc: any, key: any) => {
    //     acc[key] = axisFiltersState[key];
    //     return acc;
    //     }, {});
    // }
    // let {plotData: normalizedData, error: normalizeError} = normalizeData(plotData, xValues, xProcessing, yValues, yProcessing, axisFiltersState)

    // let sortOrder: string[] = [];
    // let errorString = ''
    // let filteredXPlotData = filterAxis(axisFiltersState, normalizedData);
    // let filteredYPlotData = structuredClone(filteredXPlotData);
    // let {plotData: groupedXPlotData, error: groupXError} = groupPlotData(filteredXPlotData, xProcessing?.groupBy, xValues, undefined, undefined, true, axisFiltersState, 'X-Axis Data', undefined, sortOrder);
    
    // if (groupXError) {
    //     errorString = groupXError
    // }

    // let {plotData: groupedYPlotData, error: groupYError} = groupPlotData(filteredYPlotData, yProcessing?.groupBy, yValues, undefined, undefined, true, axisFiltersState, 'Y-Axis Data', undefined, sortOrder);
    // if (groupYError) {
    //     errorString = groupYError
    // }

    // let {plotData: xPlotData, error: relativeXError} = relativeData(groupedXPlotData, xValues, xProcessing, yValues, undefined, axisFiltersState)
    // let {plotData: yPlotData, error: relativeYError} = relativeData(groupedYPlotData, xValues, undefined, yValues, yProcessing, axisFiltersState)

    // if (errorString) {
    //     onPlotError(errorString);
    //     return { traces: [], tileTitleList: [] };
    // }

    let takeMean = !areArraysEqual(Object.keys(xValues), Object.keys(yValues));

    for (let xItem of xPlotData) {
        let xMean: number[][] = handleArrayGroup(xItem, xValues, takeMean);
    
        if (xMean !== null) {
        xList.push(...xMean);
        }
    }

    for (let yItem of yPlotData) {
        let yMean: number[][] = handleArrayGroup(yItem, yValues, takeMean);
    
        if (yMean !== null) {
        yList.push(...yMean);
        }
    }


    for (let i = 0; i < xList.length; i++) {
        let xValues = xList[i];
        let yValues = yList[i];
        let xItem = xPlotData[i];
        let yItem = yPlotData[i];

        if (yValues && xValues && yValues.length === xValues.length) {
            for (let j = 0; j < xValues.length; j++) {
                let xValue = xValues[j];
                let yValue = yValues[j];
                // if xValue or yValue is a string, skip  
                if (typeof xValue === 'string' || typeof yValue === 'string') {
                    continue;
                }
            
                // Build the hover text for each item
                let hovertext = `X: ${!isNaN(xValue) && xValue !== null && xValue !== undefined ? xValue.toFixed(2) : 'NaN'}<br />Y: ${!isNaN(yValue) && yValue !== null && yValue !== undefined ? yValue.toFixed(2) : 'NaN'}<br />Treatment: ${xItem['Treatment_and_Dose'] || yItem['Treatment_and_Dose']}<br />Timepoint: ${xItem['Timepoint'] || yItem['Timepoint']}<br />Sample: ${xItem['Sample Title'] || yItem['Sample Title']}<br />Channel: ${xItem['channel_id'] || yItem['channel_id']}`;
                hoverText.push(hovertext);
                x.push(xValue);
                y.push(yValue);
            }
        }
    }
    const pointMax = 1000;
    if (x.length > pointMax || y.length > pointMax) {
        throw Error('Too many points to plot. Please filter the data to reduce the number of points.');
    }

    let trace = {
        x: x,
        y: y,
        name: 'default',
        mode: 'markers',
        hoverinfo: 'text',
        type: plotType,
        hovertext: hoverText,
        marker: {
            color: plotConfig.fixedColorMode ? plotConfig.fixedColor : plotConfig.colorMap[0],
            size: plotConfig.markerSize,
            line: {
                color: plotConfig.fixedColorMode ? plotConfig.fixedColor : plotConfig.colorMap[0],
                width: 2.5,
            },
            fill: 'toself',
            symbol: plotConfig.symbolMap[0],
        }
    };

    const traces = colorDataVsDataTrace(trace, plotConfig);

    // console.log("trace: ", trace);

    // const traces = [{...trace}];

    // console.log("traces: ", traces);

    return traces;
}




